/* tslint:disable */
/***
 * コード一覧
 *
 * [使い方]（例：ありなし）
 *
 * - 指定のコード値取得
 *  CodeMaster.HAVE_OR_NOT.NOT.code
 *  CodeMaster.HAVE_OR_NOT.HAVE.code
 *
 * - コード値に対するラベルの取得
 *  const label = CodeMaster.HAVE_OR_NOT.codeToEnumConstants("0")
 *  if ( !label ) {
 *    //エラー処理
 *  }
 *
 * - 指定区分のコード値一覧取得
 *  CodeMaster.HAVE_OR_NOT.values();
 *
***/

// 共通インタフェース
export class CodeMasterInterface {
    protected static  _values: CodeMasterInterface[] = [];

    /** コンストラクタ */
    public constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
    }

    /** コード値 → Enum定数への変換を行う。 */
    static codeToEnumConstants(value: string): CodeMasterInterface {
        const ret: CodeMasterInterface | undefined = this._values.find(x => x.value === value);
        if (ret === undefined) {
            throw Error(`Value "${value}" can not find in (${this._values.map(v => `${v.value}:${v.label}`).join(', ')})`);
        }
        return ret;
    }

    static values(): CodeMasterInterface[] {
        return [...this._values].sort((a, b) => a.displayOrder - b.displayOrder);
    }
}



// ありなし
export class HAVE_OR_NOT extends CodeMasterInterface {
    protected static  _values: HAVE_OR_NOT[] = [];

    /** なし */
    static readonly NOT = new HAVE_OR_NOT("0", "なし", 1);

    /** あり */
    static readonly HAVE = new HAVE_OR_NOT("1", "あり", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        HAVE_OR_NOT._values.push(this);
    }
}


// 有効無効
export class VALID_OR_NOT extends CodeMasterInterface {
    protected static  _values: VALID_OR_NOT[] = [];

    /** 無効 */
    static readonly NOT = new VALID_OR_NOT("0", "無効", 1);

    /** 有効 */
    static readonly VALID = new VALID_OR_NOT("1", "有効", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VALID_OR_NOT._values.push(this);
    }
}


// 都道府県マスタ
export class PREFECTURES_MASTER extends CodeMasterInterface {
    protected static  _values: PREFECTURES_MASTER[] = [];

    /** 北海道 */
    static readonly HOKKAIDO = new PREFECTURES_MASTER("01", "北海道", 1);

    /** 青森県 */
    static readonly AOMORI = new PREFECTURES_MASTER("02", "青森県", 2);

    /** 岩手県 */
    static readonly IWATE = new PREFECTURES_MASTER("03", "岩手県", 3);

    /** 宮城県 */
    static readonly MIYAGI = new PREFECTURES_MASTER("04", "宮城県", 4);

    /** 秋田県 */
    static readonly AKITA = new PREFECTURES_MASTER("05", "秋田県", 5);

    /** 山形県 */
    static readonly YAMAGATA = new PREFECTURES_MASTER("06", "山形県", 6);

    /** 福島県 */
    static readonly FUKUSHIMA = new PREFECTURES_MASTER("07", "福島県", 7);

    /** 茨城県 */
    static readonly IBARAKI = new PREFECTURES_MASTER("08", "茨城県", 8);

    /** 栃木県 */
    static readonly TOCHIGI = new PREFECTURES_MASTER("09", "栃木県", 9);

    /** 群馬県 */
    static readonly GUNMA = new PREFECTURES_MASTER("10", "群馬県", 10);

    /** 埼玉県 */
    static readonly SAITAMA = new PREFECTURES_MASTER("11", "埼玉県", 11);

    /** 千葉県 */
    static readonly CHIBA = new PREFECTURES_MASTER("12", "千葉県", 12);

    /** 東京都 */
    static readonly TOKYO = new PREFECTURES_MASTER("13", "東京都", 13);

    /** 神奈川県 */
    static readonly KANAGAWA = new PREFECTURES_MASTER("14", "神奈川県", 14);

    /** 新潟県 */
    static readonly NIIGATA = new PREFECTURES_MASTER("15", "新潟県", 15);

    /** 富山県 */
    static readonly TOYAMA = new PREFECTURES_MASTER("16", "富山県", 16);

    /** 石川県 */
    static readonly ISHIKAWA = new PREFECTURES_MASTER("17", "石川県", 17);

    /** 福井県 */
    static readonly FUKUI = new PREFECTURES_MASTER("18", "福井県", 18);

    /** 山梨県 */
    static readonly YAMANASHI = new PREFECTURES_MASTER("19", "山梨県", 19);

    /** 長野県 */
    static readonly NAGANO = new PREFECTURES_MASTER("20", "長野県", 20);

    /** 岐阜県 */
    static readonly GIFU = new PREFECTURES_MASTER("21", "岐阜県", 21);

    /** 静岡県 */
    static readonly SHIZUOKA = new PREFECTURES_MASTER("22", "静岡県", 22);

    /** 愛知県 */
    static readonly AICHI = new PREFECTURES_MASTER("23", "愛知県", 23);

    /** 三重県 */
    static readonly MIE = new PREFECTURES_MASTER("24", "三重県", 24);

    /** 滋賀県 */
    static readonly SHIGA = new PREFECTURES_MASTER("25", "滋賀県", 25);

    /** 京都府 */
    static readonly KYOTO = new PREFECTURES_MASTER("26", "京都府", 26);

    /** 大阪府 */
    static readonly OSAKA = new PREFECTURES_MASTER("27", "大阪府", 27);

    /** 兵庫県 */
    static readonly HYOGO = new PREFECTURES_MASTER("28", "兵庫県", 28);

    /** 奈良県 */
    static readonly NARA = new PREFECTURES_MASTER("29", "奈良県", 29);

    /** 和歌山県 */
    static readonly WAKAYAMA = new PREFECTURES_MASTER("30", "和歌山県", 30);

    /** 鳥取県 */
    static readonly TOTTORI = new PREFECTURES_MASTER("31", "鳥取県", 31);

    /** 島根県 */
    static readonly SHIMANE = new PREFECTURES_MASTER("32", "島根県", 32);

    /** 岡山県 */
    static readonly OKAYAMA = new PREFECTURES_MASTER("33", "岡山県", 33);

    /** 広島県 */
    static readonly HIROSHIMA = new PREFECTURES_MASTER("34", "広島県", 34);

    /** 山口県 */
    static readonly YAMAGUCHI = new PREFECTURES_MASTER("35", "山口県", 35);

    /** 徳島県 */
    static readonly TOKUSHIMA = new PREFECTURES_MASTER("36", "徳島県", 36);

    /** 香川県 */
    static readonly KAGAWA = new PREFECTURES_MASTER("37", "香川県", 37);

    /** 愛媛県 */
    static readonly EHIME = new PREFECTURES_MASTER("38", "愛媛県", 38);

    /** 高知県 */
    static readonly KOCHI = new PREFECTURES_MASTER("39", "高知県", 39);

    /** 福岡県 */
    static readonly FUKUOKA = new PREFECTURES_MASTER("40", "福岡県", 40);

    /** 佐賀県 */
    static readonly SAGA = new PREFECTURES_MASTER("41", "佐賀県", 41);

    /** 長崎県 */
    static readonly NAGASAKI = new PREFECTURES_MASTER("42", "長崎県", 42);

    /** 熊本県 */
    static readonly KUMAMOTO = new PREFECTURES_MASTER("43", "熊本県", 43);

    /** 大分県 */
    static readonly OITA = new PREFECTURES_MASTER("44", "大分県", 44);

    /** 宮崎県 */
    static readonly MIYAZAKI = new PREFECTURES_MASTER("45", "宮崎県", 45);

    /** 鹿児島県 */
    static readonly KAGOSHIMA = new PREFECTURES_MASTER("46", "鹿児島県", 46);

    /** 沖縄県 */
    static readonly OKINAWA = new PREFECTURES_MASTER("47", "沖縄県", 47);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PREFECTURES_MASTER._values.push(this);
    }
}


// ユーザー表示項目
export class USER_DISPLAY_ITEMS extends CodeMasterInterface {
    protected static  _values: USER_DISPLAY_ITEMS[] = [];

    /** 部屋番号 ＋ 氏名 */
    static readonly BOTH = new USER_DISPLAY_ITEMS("1", "部屋番号 ＋ 氏名", 1);

    /** 部屋番号 */
    static readonly ROOM = new USER_DISPLAY_ITEMS("2", "部屋番号", 2);

    /** 氏名 */
    static readonly NAME = new USER_DISPLAY_ITEMS("3", "氏名", 3);

    /** 非表示 */
    static readonly NONE = new USER_DISPLAY_ITEMS("4", "非表示", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        USER_DISPLAY_ITEMS._values.push(this);
    }
}


// 施設予約抽選開始日
export class FACILITY_RESERVATION_DRAWING_START_DATE extends CodeMasterInterface {
    protected static  _values: FACILITY_RESERVATION_DRAWING_START_DATE[] = [];

    /** 1 */
    static readonly VOL_1 = new FACILITY_RESERVATION_DRAWING_START_DATE("1", "1", 1);

    /** 2 */
    static readonly VOL_2 = new FACILITY_RESERVATION_DRAWING_START_DATE("2", "2", 2);

    /** 3 */
    static readonly VOL_3 = new FACILITY_RESERVATION_DRAWING_START_DATE("3", "3", 3);

    /** 4 */
    static readonly VOL_4 = new FACILITY_RESERVATION_DRAWING_START_DATE("4", "4", 4);

    /** 5 */
    static readonly VOL_5 = new FACILITY_RESERVATION_DRAWING_START_DATE("5", "5", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FACILITY_RESERVATION_DRAWING_START_DATE._values.push(this);
    }
}


// 施設予約抽選終了日
export class FACILITY_RESERVATION_DRAWING_END_DATE extends CodeMasterInterface {
    protected static  _values: FACILITY_RESERVATION_DRAWING_END_DATE[] = [];

    /** 2 */
    static readonly VOL_2 = new FACILITY_RESERVATION_DRAWING_END_DATE("2", "2", 1);

    /** 3 */
    static readonly VOL_3 = new FACILITY_RESERVATION_DRAWING_END_DATE("3", "3", 2);

    /** 4 */
    static readonly VOL_4 = new FACILITY_RESERVATION_DRAWING_END_DATE("4", "4", 3);

    /** 5 */
    static readonly VOL_5 = new FACILITY_RESERVATION_DRAWING_END_DATE("5", "5", 4);

    /** 6 */
    static readonly VOL_6 = new FACILITY_RESERVATION_DRAWING_END_DATE("6", "6", 5);

    /** 7 */
    static readonly VOL_7 = new FACILITY_RESERVATION_DRAWING_END_DATE("7", "7", 6);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FACILITY_RESERVATION_DRAWING_END_DATE._values.push(this);
    }
}


// 施設予約確定期日
export class FACILITY_RESERVATION_CONFIRMED_DATE extends CodeMasterInterface {
    protected static  _values: FACILITY_RESERVATION_CONFIRMED_DATE[] = [];

    /** 8 */
    static readonly VOL_8 = new FACILITY_RESERVATION_CONFIRMED_DATE("8", "8", 1);

    /** 9 */
    static readonly VOL_9 = new FACILITY_RESERVATION_CONFIRMED_DATE("9", "9", 2);

    /** 10 */
    static readonly VOL_10 = new FACILITY_RESERVATION_CONFIRMED_DATE("10", "10", 3);

    /** 11 */
    static readonly VOL_11 = new FACILITY_RESERVATION_CONFIRMED_DATE("11", "11", 4);

    /** 12 */
    static readonly VOL_12 = new FACILITY_RESERVATION_CONFIRMED_DATE("12", "12", 5);

    /** 13 */
    static readonly VOL_13 = new FACILITY_RESERVATION_CONFIRMED_DATE("13", "13", 6);

    /** 14 */
    static readonly VOL_14 = new FACILITY_RESERVATION_CONFIRMED_DATE("14", "14", 7);

    /** 15 */
    static readonly VOL_15 = new FACILITY_RESERVATION_CONFIRMED_DATE("15", "15", 8);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FACILITY_RESERVATION_CONFIRMED_DATE._values.push(this);
    }
}


// 利用サイト
export class AVAILABLE_SITE extends CodeMasterInterface {
    protected static  _values: AVAILABLE_SITE[] = [];

    /** 未ログイン */
    static readonly NOT_LOGIN = new AVAILABLE_SITE("0", "未ログイン", 0);

    /** 管理画面 */
    static readonly ADMIN = new AVAILABLE_SITE("1", "管理画面", 1);

    /** 居住者用画面 */
    static readonly RESIDENT = new AVAILABLE_SITE("2", "居住者用画面", 2);

    /** ゲスト用画面 */
    static readonly GUEST = new AVAILABLE_SITE("3", "ゲスト用画面", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        AVAILABLE_SITE._values.push(this);
    }
}


// 可不可
export class AVAILABLE_OR_NOT extends CodeMasterInterface {
    protected static  _values: AVAILABLE_OR_NOT[] = [];

    /** 可能 */
    static readonly AVAILABLE = new AVAILABLE_OR_NOT("1", "可能", 1);

    /** 不可 */
    static readonly UNAVAILABLE = new AVAILABLE_OR_NOT("0", "不可", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        AVAILABLE_OR_NOT._values.push(this);
    }
}


// 貸出方法
export class RENTAL_TYPE extends CodeMasterInterface {
    protected static  _values: RENTAL_TYPE[] = [];

    /** 宿泊 */
    static readonly OVERNIGHT = new RENTAL_TYPE("1", "宿泊", 1);

    /** 時間貸し */
    static readonly DURATION = new RENTAL_TYPE("0", "時間貸し", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RENTAL_TYPE._values.push(this);
    }
}


// 性別
export class SEX_MASTER extends CodeMasterInterface {
    protected static  _values: SEX_MASTER[] = [];

    /** 男性 */
    static readonly MALE = new SEX_MASTER("0", "男性", 1);

    /** 女性 */
    static readonly FEMALE = new SEX_MASTER("1", "女性", 2);

    /** 指定しない */
    static readonly UNKNOWN = new SEX_MASTER("2", "指定しない", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SEX_MASTER._values.push(this);
    }
}


// 時
export class HOURS extends CodeMasterInterface {
    protected static  _values: HOURS[] = [];

    /** 0 */
    static readonly VOL_0 = new HOURS("0", "0", 1);

    /** 1 */
    static readonly VOL_1 = new HOURS("1", "1", 2);

    /** 2 */
    static readonly VOL_2 = new HOURS("2", "2", 3);

    /** 3 */
    static readonly VOL_3 = new HOURS("3", "3", 4);

    /** 4 */
    static readonly VOL_4 = new HOURS("4", "4", 5);

    /** 5 */
    static readonly VOL_5 = new HOURS("5", "5", 6);

    /** 6 */
    static readonly VOL_6 = new HOURS("6", "6", 7);

    /** 7 */
    static readonly VOL_7 = new HOURS("7", "7", 8);

    /** 8 */
    static readonly VOL_8 = new HOURS("8", "8", 9);

    /** 9 */
    static readonly VOL_9 = new HOURS("9", "9", 10);

    /** 10 */
    static readonly VOL_10 = new HOURS("10", "10", 11);

    /** 11 */
    static readonly VOL_11 = new HOURS("11", "11", 12);

    /** 12 */
    static readonly VOL_12 = new HOURS("12", "12", 13);

    /** 13 */
    static readonly VOL_13 = new HOURS("13", "13", 14);

    /** 14 */
    static readonly VOL_14 = new HOURS("14", "14", 15);

    /** 15 */
    static readonly VOL_15 = new HOURS("15", "15", 16);

    /** 16 */
    static readonly VOL_16 = new HOURS("16", "16", 17);

    /** 17 */
    static readonly VOL_17 = new HOURS("17", "17", 18);

    /** 18 */
    static readonly VOL_18 = new HOURS("18", "18", 19);

    /** 19 */
    static readonly VOL_19 = new HOURS("19", "19", 20);

    /** 20 */
    static readonly VOL_20 = new HOURS("20", "20", 21);

    /** 21 */
    static readonly VOL_21 = new HOURS("21", "21", 22);

    /** 22 */
    static readonly VOL_22 = new HOURS("22", "22", 23);

    /** 23 */
    static readonly VOL_23 = new HOURS("23", "23", 24);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        HOURS._values.push(this);
    }
}


// 分
export class MINUTS extends CodeMasterInterface {
    protected static  _values: MINUTS[] = [];

    /** 0 */
    static readonly VOL_0 = new MINUTS("0", "0", 1);

    /** 1 */
    static readonly VOL_1 = new MINUTS("1", "1", 2);

    /** 2 */
    static readonly VOL_2 = new MINUTS("2", "2", 3);

    /** 3 */
    static readonly VOL_3 = new MINUTS("3", "3", 4);

    /** 4 */
    static readonly VOL_4 = new MINUTS("4", "4", 5);

    /** 5 */
    static readonly VOL_5 = new MINUTS("5", "5", 6);

    /** 6 */
    static readonly VOL_6 = new MINUTS("6", "6", 7);

    /** 7 */
    static readonly VOL_7 = new MINUTS("7", "7", 8);

    /** 8 */
    static readonly VOL_8 = new MINUTS("8", "8", 9);

    /** 9 */
    static readonly VOL_9 = new MINUTS("9", "9", 10);

    /** 10 */
    static readonly VOL_10 = new MINUTS("10", "10", 11);

    /** 11 */
    static readonly VOL_11 = new MINUTS("11", "11", 12);

    /** 12 */
    static readonly VOL_12 = new MINUTS("12", "12", 13);

    /** 13 */
    static readonly VOL_13 = new MINUTS("13", "13", 14);

    /** 14 */
    static readonly VOL_14 = new MINUTS("14", "14", 15);

    /** 15 */
    static readonly VOL_15 = new MINUTS("15", "15", 16);

    /** 16 */
    static readonly VOL_16 = new MINUTS("16", "16", 17);

    /** 17 */
    static readonly VOL_17 = new MINUTS("17", "17", 18);

    /** 18 */
    static readonly VOL_18 = new MINUTS("18", "18", 19);

    /** 19 */
    static readonly VOL_19 = new MINUTS("19", "19", 20);

    /** 20 */
    static readonly VOL_20 = new MINUTS("20", "20", 21);

    /** 21 */
    static readonly VOL_21 = new MINUTS("21", "21", 22);

    /** 22 */
    static readonly VOL_22 = new MINUTS("22", "22", 23);

    /** 23 */
    static readonly VOL_23 = new MINUTS("23", "23", 24);

    /** 24 */
    static readonly VOL_24 = new MINUTS("24", "24", 25);

    /** 25 */
    static readonly VOL_25 = new MINUTS("25", "25", 26);

    /** 26 */
    static readonly VOL_26 = new MINUTS("26", "26", 27);

    /** 27 */
    static readonly VOL_27 = new MINUTS("27", "27", 28);

    /** 28 */
    static readonly VOL_28 = new MINUTS("28", "28", 29);

    /** 29 */
    static readonly VOL_29 = new MINUTS("29", "29", 30);

    /** 30 */
    static readonly VOL_30 = new MINUTS("30", "30", 31);

    /** 31 */
    static readonly VOL_31 = new MINUTS("31", "31", 32);

    /** 32 */
    static readonly VOL_32 = new MINUTS("32", "32", 33);

    /** 33 */
    static readonly VOL_33 = new MINUTS("33", "33", 34);

    /** 34 */
    static readonly VOL_34 = new MINUTS("34", "34", 35);

    /** 35 */
    static readonly VOL_35 = new MINUTS("35", "35", 36);

    /** 36 */
    static readonly VOL_36 = new MINUTS("36", "36", 37);

    /** 37 */
    static readonly VOL_37 = new MINUTS("37", "37", 38);

    /** 38 */
    static readonly VOL_38 = new MINUTS("38", "38", 39);

    /** 39 */
    static readonly VOL_39 = new MINUTS("39", "39", 40);

    /** 40 */
    static readonly VOL_40 = new MINUTS("40", "40", 41);

    /** 41 */
    static readonly VOL_41 = new MINUTS("41", "41", 42);

    /** 42 */
    static readonly VOL_42 = new MINUTS("42", "42", 43);

    /** 43 */
    static readonly VOL_43 = new MINUTS("43", "43", 44);

    /** 44 */
    static readonly VOL_44 = new MINUTS("44", "44", 45);

    /** 45 */
    static readonly VOL_45 = new MINUTS("45", "45", 46);

    /** 46 */
    static readonly VOL_46 = new MINUTS("46", "46", 47);

    /** 47 */
    static readonly VOL_47 = new MINUTS("47", "47", 48);

    /** 48 */
    static readonly VOL_48 = new MINUTS("48", "48", 49);

    /** 49 */
    static readonly VOL_49 = new MINUTS("49", "49", 50);

    /** 50 */
    static readonly VOL_50 = new MINUTS("50", "50", 51);

    /** 51 */
    static readonly VOL_51 = new MINUTS("51", "51", 52);

    /** 52 */
    static readonly VOL_52 = new MINUTS("52", "52", 53);

    /** 53 */
    static readonly VOL_53 = new MINUTS("53", "53", 54);

    /** 54 */
    static readonly VOL_54 = new MINUTS("54", "54", 55);

    /** 55 */
    static readonly VOL_55 = new MINUTS("55", "55", 56);

    /** 56 */
    static readonly VOL_56 = new MINUTS("56", "56", 57);

    /** 57 */
    static readonly VOL_57 = new MINUTS("57", "57", 58);

    /** 58 */
    static readonly VOL_58 = new MINUTS("58", "58", 59);

    /** 59 */
    static readonly VOL_59 = new MINUTS("59", "59", 60);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MINUTS._values.push(this);
    }
}


// 単位時間(単位)
export class UNIT_TIME extends CodeMasterInterface {
    protected static  _values: UNIT_TIME[] = [];

    /** 分 */
    static readonly MINUTES = new UNIT_TIME("0", "分", 1);

    /** 時間 */
    static readonly HOUR = new UNIT_TIME("1", "時間", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        UNIT_TIME._values.push(this);
    }
}


// 居住者予約可否
export class RESERVATION_ACCEPTABILITY_FOR_RESIDENT extends CodeMasterInterface {
    protected static  _values: RESERVATION_ACCEPTABILITY_FOR_RESIDENT[] = [];

    /** 居住者＋代行者 */
    static readonly BOTH = new RESERVATION_ACCEPTABILITY_FOR_RESIDENT("1", "居住者＋代行者", 1);

    /** 代行者のみ */
    static readonly AGENT = new RESERVATION_ACCEPTABILITY_FOR_RESIDENT("0", "代行者のみ", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESERVATION_ACCEPTABILITY_FOR_RESIDENT._values.push(this);
    }
}


// 施設予約受付開始単位
export class UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME extends CodeMasterInterface {
    protected static  _values: UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME[] = [];

    /** 制限なし */
    static readonly UNSPECIFIED = new UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME("0", "制限なし", 1);

    /** 月指定 */
    static readonly SPECIFIED_MONTH = new UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME("1", "月指定", 2);

    /** 日指定 */
    static readonly SPECIFIED_DAY = new UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME("2", "日指定", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME._values.push(this);
    }
}


// 予約締切・キャンセル指定単位
export class DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL extends CodeMasterInterface {
    protected static  _values: DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL[] = [];

    /** 制限なし */
    static readonly UNSPECIFIED = new DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL("0", "制限なし", 1);

    /** 日指定 */
    static readonly SPECIFIED_DAY = new DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL("1", "日指定", 2);

    /** 当日時間指定 */
    static readonly SPECIFIED_TIME = new DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL("2", "当日時間指定", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL._values.push(this);
    }
}


// 清掃時間
export class CLEANING_TIME extends CodeMasterInterface {
    protected static  _values: CLEANING_TIME[] = [];

    /** 0 */
    static readonly VOL_0 = new CLEANING_TIME("0", "0", 1);

    /** 5 */
    static readonly VOL_5 = new CLEANING_TIME("5", "5", 2);

    /** 10 */
    static readonly VOL_10 = new CLEANING_TIME("10", "10", 3);

    /** 15 */
    static readonly VOL_15 = new CLEANING_TIME("15", "15", 4);

    /** 20 */
    static readonly VOL_20 = new CLEANING_TIME("20", "20", 5);

    /** 25 */
    static readonly VOL_25 = new CLEANING_TIME("25", "25", 6);

    /** 30 */
    static readonly VOL_30 = new CLEANING_TIME("30", "30", 7);

    /** 35 */
    static readonly VOL_35 = new CLEANING_TIME("35", "35", 8);

    /** 40 */
    static readonly VOL_40 = new CLEANING_TIME("40", "40", 9);

    /** 45 */
    static readonly VOL_45 = new CLEANING_TIME("45", "45", 10);

    /** 50 */
    static readonly VOL_50 = new CLEANING_TIME("50", "50", 11);

    /** 55 */
    static readonly VOL_55 = new CLEANING_TIME("55", "55", 12);

    /** 60 */
    static readonly VOL_60 = new CLEANING_TIME("60", "60", 13);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CLEANING_TIME._values.push(this);
    }
}


// 公開設定
export class PUBLISHING_SETTING extends CodeMasterInterface {
    protected static  _values: PUBLISHING_SETTING[] = [];

    /** 公開 */
    static readonly PUBLIC = new PUBLISHING_SETTING("1", "公開", 1);

    /** 非公開 */
    static readonly PRIVATE = new PUBLISHING_SETTING("0", "非公開", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PUBLISHING_SETTING._values.push(this);
    }
}


// 時(24)
export class HOURS_24 extends CodeMasterInterface {
    protected static  _values: HOURS_24[] = [];

    /** 0 */
    static readonly VOL_0 = new HOURS_24("0", "0", 1);

    /** 1 */
    static readonly VOL_1 = new HOURS_24("1", "1", 2);

    /** 2 */
    static readonly VOL_2 = new HOURS_24("2", "2", 3);

    /** 3 */
    static readonly VOL_3 = new HOURS_24("3", "3", 4);

    /** 4 */
    static readonly VOL_4 = new HOURS_24("4", "4", 5);

    /** 5 */
    static readonly VOL_5 = new HOURS_24("5", "5", 6);

    /** 6 */
    static readonly VOL_6 = new HOURS_24("6", "6", 7);

    /** 7 */
    static readonly VOL_7 = new HOURS_24("7", "7", 8);

    /** 8 */
    static readonly VOL_8 = new HOURS_24("8", "8", 9);

    /** 9 */
    static readonly VOL_9 = new HOURS_24("9", "9", 10);

    /** 10 */
    static readonly VOL_10 = new HOURS_24("10", "10", 11);

    /** 11 */
    static readonly VOL_11 = new HOURS_24("11", "11", 12);

    /** 12 */
    static readonly VOL_12 = new HOURS_24("12", "12", 13);

    /** 13 */
    static readonly VOL_13 = new HOURS_24("13", "13", 14);

    /** 14 */
    static readonly VOL_14 = new HOURS_24("14", "14", 15);

    /** 15 */
    static readonly VOL_15 = new HOURS_24("15", "15", 16);

    /** 16 */
    static readonly VOL_16 = new HOURS_24("16", "16", 17);

    /** 17 */
    static readonly VOL_17 = new HOURS_24("17", "17", 18);

    /** 18 */
    static readonly VOL_18 = new HOURS_24("18", "18", 19);

    /** 19 */
    static readonly VOL_19 = new HOURS_24("19", "19", 20);

    /** 20 */
    static readonly VOL_20 = new HOURS_24("20", "20", 21);

    /** 21 */
    static readonly VOL_21 = new HOURS_24("21", "21", 22);

    /** 22 */
    static readonly VOL_22 = new HOURS_24("22", "22", 23);

    /** 23 */
    static readonly VOL_23 = new HOURS_24("23", "23", 24);

    /** 24 */
    static readonly VOL_24 = new HOURS_24("24", "24", 25);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        HOURS_24._values.push(this);
    }
}


// 宿泊可能数
export class NUMBER_OF_TIMES_TO_STAY extends CodeMasterInterface {
    protected static  _values: NUMBER_OF_TIMES_TO_STAY[] = [];

    /** 1 */
    static readonly VOL_1 = new NUMBER_OF_TIMES_TO_STAY("1", "1", 1);

    /** 2 */
    static readonly VOL_2 = new NUMBER_OF_TIMES_TO_STAY("2", "2", 2);

    /** 3 */
    static readonly VOL_3 = new NUMBER_OF_TIMES_TO_STAY("3", "3", 3);

    /** 4 */
    static readonly VOL_4 = new NUMBER_OF_TIMES_TO_STAY("4", "4", 4);

    /** 5 */
    static readonly VOL_5 = new NUMBER_OF_TIMES_TO_STAY("5", "5", 5);

    /** 6 */
    static readonly VOL_6 = new NUMBER_OF_TIMES_TO_STAY("6", "6", 6);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        NUMBER_OF_TIMES_TO_STAY._values.push(this);
    }
}


// 営業スケジュール単位
export class UNIT_OF_BUSINESS_SCHEDULE extends CodeMasterInterface {
    protected static  _values: UNIT_OF_BUSINESS_SCHEDULE[] = [];

    /** 日曜日 */
    static readonly SUNDAY = new UNIT_OF_BUSINESS_SCHEDULE("1", "日曜日", 1);

    /** 月曜日 */
    static readonly MONDAY = new UNIT_OF_BUSINESS_SCHEDULE("2", "月曜日", 2);

    /** 火曜日 */
    static readonly TUESDAY = new UNIT_OF_BUSINESS_SCHEDULE("3", "火曜日", 3);

    /** 水曜日 */
    static readonly WEDNESDAY = new UNIT_OF_BUSINESS_SCHEDULE("4", "水曜日", 4);

    /** 木曜日 */
    static readonly THURSDAY = new UNIT_OF_BUSINESS_SCHEDULE("5", "木曜日", 5);

    /** 金曜日 */
    static readonly FRIDAY = new UNIT_OF_BUSINESS_SCHEDULE("6", "金曜日", 6);

    /** 土曜日 */
    static readonly SATURDAY = new UNIT_OF_BUSINESS_SCHEDULE("7", "土曜日", 7);

    /** 祝日 */
    static readonly HOLIDAY = new UNIT_OF_BUSINESS_SCHEDULE("8", "祝日", 8);

    /** 全ての曜日 */
    static readonly ALL_DAYS = new UNIT_OF_BUSINESS_SCHEDULE("9", "全ての曜日", 9);

    /** 曜日指定なし・日またぎ */
    static readonly DATE_STRADDLE = new UNIT_OF_BUSINESS_SCHEDULE("10", "曜日指定なし・日またぎ", 10);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        UNIT_OF_BUSINESS_SCHEDULE._values.push(this);
    }
}


// 予約種別
export class RESERVATION_TYPE extends CodeMasterInterface {
    protected static  _values: RESERVATION_TYPE[] = [];

    /** 先着予約 */
    static readonly FIRST_COME = new RESERVATION_TYPE("0", "先着予約", 1);

    /** 抽選予約 */
    static readonly LOTTERY = new RESERVATION_TYPE("1", "抽選予約", 2);

    /** 追加課金 */
    static readonly ADDITIONAL_CHARGE = new RESERVATION_TYPE("2", "追加課金", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESERVATION_TYPE._values.push(this);
    }
}


// 予約時間単位(分)
export class RESERVATION_TIME_UNIT_MINUTES extends CodeMasterInterface {
    protected static  _values: RESERVATION_TIME_UNIT_MINUTES[] = [];

    /** 0 */
    static readonly VOL_0 = new RESERVATION_TIME_UNIT_MINUTES("0", "0", 1);

    /** 5 */
    static readonly VOL_5 = new RESERVATION_TIME_UNIT_MINUTES("5", "5", 2);

    /** 10 */
    static readonly VOL_10 = new RESERVATION_TIME_UNIT_MINUTES("10", "10", 3);

    /** 15 */
    static readonly VOL_15 = new RESERVATION_TIME_UNIT_MINUTES("15", "15", 4);

    /** 20 */
    static readonly VOL_20 = new RESERVATION_TIME_UNIT_MINUTES("20", "20", 5);

    /** 25 */
    static readonly VOL_25 = new RESERVATION_TIME_UNIT_MINUTES("25", "25", 6);

    /** 30 */
    static readonly VOL_30 = new RESERVATION_TIME_UNIT_MINUTES("30", "30", 7);

    /** 35 */
    static readonly VOL_35 = new RESERVATION_TIME_UNIT_MINUTES("35", "35", 8);

    /** 40 */
    static readonly VOL_40 = new RESERVATION_TIME_UNIT_MINUTES("40", "40", 9);

    /** 45 */
    static readonly VOL_45 = new RESERVATION_TIME_UNIT_MINUTES("45", "45", 10);

    /** 50 */
    static readonly VOL_50 = new RESERVATION_TIME_UNIT_MINUTES("50", "50", 11);

    /** 55 */
    static readonly VOL_55 = new RESERVATION_TIME_UNIT_MINUTES("55", "55", 12);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESERVATION_TIME_UNIT_MINUTES._values.push(this);
    }
}


// お支払方法
export class PAYMENT_TYPE extends CodeMasterInterface {
    protected static  _values: PAYMENT_TYPE[] = [];

    /** 管理費口座振替 */
    static readonly ADMIN_TRANSFER_ACCOUNT = new PAYMENT_TYPE("0", "管理費口座振替", 1);

    /** 現金 */
    static readonly CASH = new PAYMENT_TYPE("1", "現金", 2);

    /** サービス口座振替 */
    static readonly SERVICE_TRANSFER_ACCOUNT = new PAYMENT_TYPE("2", "サービス口座振替", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PAYMENT_TYPE._values.push(this);
    }
}


// 現金支払ステータス
export class CASH_PAYMENT_STATUS extends CodeMasterInterface {
    protected static  _values: CASH_PAYMENT_STATUS[] = [];

    /** 未 */
    static readonly YET_PAID = new CASH_PAYMENT_STATUS("0", "未", 1);

    /** 済 */
    static readonly PAID = new CASH_PAYMENT_STATUS("1", "済", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CASH_PAYMENT_STATUS._values.push(this);
    }
}


// 施設予約区分
export class FACILITY_RESERVATION_CLASSIFICATION extends CodeMasterInterface {
    protected static  _values: FACILITY_RESERVATION_CLASSIFICATION[] = [];

    /** 居住者予約 */
    static readonly RESIDENT = new FACILITY_RESERVATION_CLASSIFICATION("1", "居住者予約", 1);

    /** 代行予約 */
    static readonly AGENT = new FACILITY_RESERVATION_CLASSIFICATION("2", "代行予約", 2);

    /** 管理者予約 */
    static readonly ADMIN = new FACILITY_RESERVATION_CLASSIFICATION("3", "管理者予約", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FACILITY_RESERVATION_CLASSIFICATION._values.push(this);
    }
}


// 予約ステータス
export class RESERVATION_STATUS extends CodeMasterInterface {
    protected static  _values: RESERVATION_STATUS[] = [];

    /** 抽選前 */
    static readonly BEFORE_LOTTERY = new RESERVATION_STATUS("0", "抽選前", 1);

    /** 確定待ち */
    static readonly WAITING_FOR_CONFIRMATION = new RESERVATION_STATUS("1", "確定待ち", 2);

    /** 確定 */
    static readonly ELECTION = new RESERVATION_STATUS("2", "確定", 3);

    /** 落選 */
    static readonly DIS_ELECTION = new RESERVATION_STATUS("3", "落選", 4);

    /** キャンセル */
    static readonly CANCEL = new RESERVATION_STATUS("9", "キャンセル", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESERVATION_STATUS._values.push(this);
    }
}


// 居住者ステータス
export class RESIDENT_STATUS extends CodeMasterInterface {
    protected static  _values: RESIDENT_STATUS[] = [];

    /** 未登録 */
    static readonly UNREGISTERED = new RESIDENT_STATUS("0", "未登録", 1);

    /** 有効期間前 */
    static readonly BEFORE_OCCUPANCY = new RESIDENT_STATUS("4", "有効期間前", 2);

    /** 登録済 */
    static readonly REGISTERED = new RESIDENT_STATUS("1", "登録済", 3);

    /** 廃止 */
    static readonly ABOLITION = new RESIDENT_STATUS("2", "廃止", 4);

    /** 長谷工ID退会 */
    static readonly HASEKO_WITHDRAW = new RESIDENT_STATUS("3", "長谷工ID退会", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_STATUS._values.push(this);
    }
}


// 料金単位
export class CHARGE_UNIT extends CodeMasterInterface {
    protected static  _values: CHARGE_UNIT[] = [];

    /** 分 */
    static readonly MINUTE = new CHARGE_UNIT("0", "分", 1);

    /** 時間 */
    static readonly TIME = new CHARGE_UNIT("1", "時間", 2);

    /** 固定料金 */
    static readonly FIXED = new CHARGE_UNIT("2", "固定料金", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CHARGE_UNIT._values.push(this);
    }
}


// 管理者ステータス
export class MANAGER_STATUS extends CodeMasterInterface {
    protected static  _values: MANAGER_STATUS[] = [];

    /** ログイン不可 */
    static readonly LOGIN_FAIL = new MANAGER_STATUS("0", "ログイン不可", 1);

    /** 有効 */
    static readonly VALID = new MANAGER_STATUS("1", "有効", 2);

    /** 削除 */
    static readonly DELETE = new MANAGER_STATUS("2", "削除", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MANAGER_STATUS._values.push(this);
    }
}


// 有効無効（チェック）
export class VALID_OR_NOT_CHECK extends CodeMasterInterface {
    protected static  _values: VALID_OR_NOT_CHECK[] = [];

    /**  */
    static readonly NOT = new VALID_OR_NOT_CHECK("0", "", 1);

    /** ✓ */
    static readonly VALID = new VALID_OR_NOT_CHECK("1", "✓", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VALID_OR_NOT_CHECK._values.push(this);
    }
}


// 予約時間単位(分)0なし
export class RESERVATION_TIME_UNIT_MINUTES_NOT0 extends CodeMasterInterface {
    protected static  _values: RESERVATION_TIME_UNIT_MINUTES_NOT0[] = [];

    /** 5 */
    static readonly VOL_5 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("5", "5", 1);

    /** 10 */
    static readonly VOL_10 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("10", "10", 2);

    /** 15 */
    static readonly VOL_15 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("15", "15", 3);

    /** 20 */
    static readonly VOL_20 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("20", "20", 4);

    /** 25 */
    static readonly VOL_25 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("25", "25", 5);

    /** 30 */
    static readonly VOL_30 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("30", "30", 6);

    /** 35 */
    static readonly VOL_35 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("35", "35", 7);

    /** 40 */
    static readonly VOL_40 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("40", "40", 8);

    /** 45 */
    static readonly VOL_45 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("45", "45", 9);

    /** 50 */
    static readonly VOL_50 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("50", "50", 10);

    /** 55 */
    static readonly VOL_55 = new RESERVATION_TIME_UNIT_MINUTES_NOT0("55", "55", 11);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESERVATION_TIME_UNIT_MINUTES_NOT0._values.push(this);
    }
}


// イベントカテゴリ
export class EVENT_CATEGORY extends CodeMasterInterface {
    protected static  _values: EVENT_CATEGORY[] = [];

    /** ごみの日 */
    static readonly TRASH_DAY = new EVENT_CATEGORY("0", "ごみの日", 1);

    /** メンテナンス */
    static readonly MAINTENANCE = new EVENT_CATEGORY("1", "メンテナンス", 2);

    /** 清掃 */
    static readonly CLEANING = new EVENT_CATEGORY("2", "清掃", 3);

    /** その他イベント */
    static readonly OTHER_EVENT = new EVENT_CATEGORY("3", "その他イベント", 4);

    /** その他 */
    static readonly OTHER = new EVENT_CATEGORY("4", "その他", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_CATEGORY._values.push(this);
    }
}


// イベント項目-ごみの日
export class EVENT_ITEM_GARBAGE_DAY extends CodeMasterInterface {
    protected static  _values: EVENT_ITEM_GARBAGE_DAY[] = [];

    /** 可燃ごみ */
    static readonly BURNABLE = new EVENT_ITEM_GARBAGE_DAY("0", "可燃ごみ", 1);

    /** リサイクル */
    static readonly RECYCLE = new EVENT_ITEM_GARBAGE_DAY("1", "リサイクル", 2);

    /** 粗大ごみ */
    static readonly BULK = new EVENT_ITEM_GARBAGE_DAY("2", "粗大ごみ", 3);

    /** 危険ごみ */
    static readonly DANGER = new EVENT_ITEM_GARBAGE_DAY("3", "危険ごみ", 4);

    /** ペットボトル */
    static readonly PET = new EVENT_ITEM_GARBAGE_DAY("4", "ペットボトル", 5);

    /** カンビン */
    static readonly CAN_BOTTLE = new EVENT_ITEM_GARBAGE_DAY("5", "カンビン", 6);

    /** 不燃ごみ */
    static readonly NON_BURNABLE = new EVENT_ITEM_GARBAGE_DAY("6", "不燃ごみ", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_ITEM_GARBAGE_DAY._values.push(this);
    }
}


// イベント項目-メンテナンス
export class EVENT_ITEM_MAINTENANCE extends CodeMasterInterface {
    protected static  _values: EVENT_ITEM_MAINTENANCE[] = [];

    /** システムメンテナンス */
    static readonly SYSTEM = new EVENT_ITEM_MAINTENANCE("0", "システムメンテナンス", 1);

    /** 植栽メンテナンス */
    static readonly SOFTSCAPE = new EVENT_ITEM_MAINTENANCE("1", "植栽メンテナンス", 2);

    /** 整備メンテナンス */
    static readonly CONDITION = new EVENT_ITEM_MAINTENANCE("2", "整備メンテナンス", 3);

    /** 設備点検 */
    static readonly EQUIPMENT = new EVENT_ITEM_MAINTENANCE("3", "設備点検", 4);

    /** 消防設備点検 */
    static readonly FIREFIGHTING_EQUIPMENT = new EVENT_ITEM_MAINTENANCE("4", "消防設備点検", 5);

    /** 駐車場点検 */
    static readonly PARK = new EVENT_ITEM_MAINTENANCE("5", "駐車場点検", 6);

    /** EV点検 */
    static readonly ELEVATOR = new EVENT_ITEM_MAINTENANCE("6", "EV点検", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_ITEM_MAINTENANCE._values.push(this);
    }
}


// イベント項目-清掃
export class EVENT_ITEM_CLEANING extends CodeMasterInterface {
    protected static  _values: EVENT_ITEM_CLEANING[] = [];

    /** 定期清掃 */
    static readonly FIXED_TIME = new EVENT_ITEM_CLEANING("0", "定期清掃", 1);

    /** 排水清掃 */
    static readonly DISCHARGED_WATER = new EVENT_ITEM_CLEANING("1", "排水清掃", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_ITEM_CLEANING._values.push(this);
    }
}


// イベント項目-その他イベント
export class EVENT_ITEM_OTHER_EVENTS extends CodeMasterInterface {
    protected static  _values: EVENT_ITEM_OTHER_EVENTS[] = [];

    /** 組合理事会 */
    static readonly ASSOC = new EVENT_ITEM_OTHER_EVENTS("0", "組合理事会", 1);

    /** 組合総会 */
    static readonly CONGRESS = new EVENT_ITEM_OTHER_EVENTS("1", "組合総会", 2);

    /** 説明会 */
    static readonly BRIEFING = new EVENT_ITEM_OTHER_EVENTS("2", "説明会", 3);

    /** 委員会 */
    static readonly COMMITTEE = new EVENT_ITEM_OTHER_EVENTS("3", "委員会", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_ITEM_OTHER_EVENTS._values.push(this);
    }
}


// イベント項目-その他
export class EVENT_ITEM_OTHER extends CodeMasterInterface {
    protected static  _values: EVENT_ITEM_OTHER[] = [];

    /** その他 */
    static readonly OTHER = new EVENT_ITEM_OTHER("0", "その他", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_ITEM_OTHER._values.push(this);
    }
}


// イベント繰り返し単位
export class EVENT_REPEAT_UNIT extends CodeMasterInterface {
    protected static  _values: EVENT_REPEAT_UNIT[] = [];

    /** 繰り返し週/曜日指定 */
    static readonly WEEK_OR_DAY_OF_WEEK = new EVENT_REPEAT_UNIT("0", "繰り返し週/曜日指定", 1);

    /** 繰り返し日指定 */
    static readonly DAY = new EVENT_REPEAT_UNIT("1", "繰り返し日指定", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_REPEAT_UNIT._values.push(this);
    }
}


// イベント繰り返し週単位
export class EVENT_REPEAT_UNIT_FOR_WEEK extends CodeMasterInterface {
    protected static  _values: EVENT_REPEAT_UNIT_FOR_WEEK[] = [];

    /** 毎週 */
    static readonly EVERY_WEEK = new EVENT_REPEAT_UNIT_FOR_WEEK("0", "毎週", 1);

    /** 隔週 */
    static readonly ALTERNATE_WEEK = new EVENT_REPEAT_UNIT_FOR_WEEK("1", "隔週", 2);

    /** 週選択 */
    static readonly SELECTION_WEEK = new EVENT_REPEAT_UNIT_FOR_WEEK("2", "週選択", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_REPEAT_UNIT_FOR_WEEK._values.push(this);
    }
}


// イベント繰り返し週
export class EVENT_REPEAT_WEEK extends CodeMasterInterface {
    protected static  _values: EVENT_REPEAT_WEEK[] = [];

    /** 第一 */
    static readonly FIRST_WEEK = new EVENT_REPEAT_WEEK("1", "第一", 1);

    /** 第二 */
    static readonly SECOND_WEEK = new EVENT_REPEAT_WEEK("2", "第二", 2);

    /** 第三 */
    static readonly THIRD_WEEK = new EVENT_REPEAT_WEEK("4", "第三", 3);

    /** 第四 */
    static readonly FOURTH_WEEK = new EVENT_REPEAT_WEEK("8", "第四", 4);

    /** 第五 */
    static readonly FIFTH_WEEK = new EVENT_REPEAT_WEEK("16", "第五", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_REPEAT_WEEK._values.push(this);
    }
}


// イベント繰り返し曜日
export class EVENT_REPEAT_DAY_OF_THE_WEEK extends CodeMasterInterface {
    protected static  _values: EVENT_REPEAT_DAY_OF_THE_WEEK[] = [];

    /** 月 */
    static readonly MONDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("1", "月", 2);

    /** 火 */
    static readonly TUESDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("2", "火", 3);

    /** 水 */
    static readonly WEDNESDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("4", "水", 4);

    /** 木 */
    static readonly THURSDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("8", "木", 5);

    /** 金 */
    static readonly FRIDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("16", "金", 6);

    /** 土 */
    static readonly SATURDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("32", "土", 7);

    /** 日 */
    static readonly SUNDAY = new EVENT_REPEAT_DAY_OF_THE_WEEK("64", "日", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_REPEAT_DAY_OF_THE_WEEK._values.push(this);
    }
}


// イベント繰り返し日
export class EVENT_REPEAT_DAY extends CodeMasterInterface {
    protected static  _values: EVENT_REPEAT_DAY[] = [];

    /** 1 */
    static readonly VOL_1 = new EVENT_REPEAT_DAY("1", "1", 1);

    /** 2 */
    static readonly VOL_2 = new EVENT_REPEAT_DAY("2", "2", 2);

    /** 3 */
    static readonly VOL_3 = new EVENT_REPEAT_DAY("3", "3", 3);

    /** 4 */
    static readonly VOL_4 = new EVENT_REPEAT_DAY("4", "4", 4);

    /** 5 */
    static readonly VOL_5 = new EVENT_REPEAT_DAY("5", "5", 5);

    /** 6 */
    static readonly VOL_6 = new EVENT_REPEAT_DAY("6", "6", 6);

    /** 7 */
    static readonly VOL_7 = new EVENT_REPEAT_DAY("7", "7", 7);

    /** 8 */
    static readonly VOL_8 = new EVENT_REPEAT_DAY("8", "8", 8);

    /** 9 */
    static readonly VOL_9 = new EVENT_REPEAT_DAY("9", "9", 9);

    /** 10 */
    static readonly VOL_10 = new EVENT_REPEAT_DAY("10", "10", 10);

    /** 11 */
    static readonly VOL_11 = new EVENT_REPEAT_DAY("11", "11", 11);

    /** 12 */
    static readonly VOL_12 = new EVENT_REPEAT_DAY("12", "12", 12);

    /** 13 */
    static readonly VOL_13 = new EVENT_REPEAT_DAY("13", "13", 13);

    /** 14 */
    static readonly VOL_14 = new EVENT_REPEAT_DAY("14", "14", 14);

    /** 15 */
    static readonly VOL_15 = new EVENT_REPEAT_DAY("15", "15", 15);

    /** 16 */
    static readonly VOL_16 = new EVENT_REPEAT_DAY("16", "16", 16);

    /** 17 */
    static readonly VOL_17 = new EVENT_REPEAT_DAY("17", "17", 17);

    /** 18 */
    static readonly VOL_18 = new EVENT_REPEAT_DAY("18", "18", 18);

    /** 19 */
    static readonly VOL_19 = new EVENT_REPEAT_DAY("19", "19", 19);

    /** 20 */
    static readonly VOL_20 = new EVENT_REPEAT_DAY("20", "20", 20);

    /** 21 */
    static readonly VOL_21 = new EVENT_REPEAT_DAY("21", "21", 21);

    /** 22 */
    static readonly VOL_22 = new EVENT_REPEAT_DAY("22", "22", 22);

    /** 23 */
    static readonly VOL_23 = new EVENT_REPEAT_DAY("23", "23", 23);

    /** 24 */
    static readonly VOL_24 = new EVENT_REPEAT_DAY("24", "24", 24);

    /** 25 */
    static readonly VOL_25 = new EVENT_REPEAT_DAY("25", "25", 25);

    /** 26 */
    static readonly VOL_26 = new EVENT_REPEAT_DAY("26", "26", 26);

    /** 27 */
    static readonly VOL_27 = new EVENT_REPEAT_DAY("27", "27", 27);

    /** 28 */
    static readonly VOL_28 = new EVENT_REPEAT_DAY("28", "28", 28);

    /** 29 */
    static readonly VOL_29 = new EVENT_REPEAT_DAY("29", "29", 29);

    /** 30 */
    static readonly VOL_30 = new EVENT_REPEAT_DAY("30", "30", 30);

    /** 31 */
    static readonly VOL_31 = new EVENT_REPEAT_DAY("31", "31", 31);

    /** 月末 */
    static readonly END_OF_MONTH = new EVENT_REPEAT_DAY("99", "月末", 32);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_REPEAT_DAY._values.push(this);
    }
}


// ターゲット属性
export class TARGET_ATT extends CodeMasterInterface {
    protected static  _values: TARGET_ATT[] = [];

    /** 新規ウィンドウ */
    static readonly NEW = new TARGET_ATT("0", "新規ウィンドウ", 1);

    /** なし */
    static readonly NONE = new TARGET_ATT("1", "なし", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        TARGET_ATT._values.push(this);
    }
}


// 居住者ユーザタイプ
export class RESIDENT_USER_TYPE extends CodeMasterInterface {
    protected static  _values: RESIDENT_USER_TYPE[] = [];

    /** メインユーザ */
    static readonly MAIN = new RESIDENT_USER_TYPE("1", "メインユーザ", 1);

    /** サブユーザ */
    static readonly SUB = new RESIDENT_USER_TYPE("2", "サブユーザ", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_USER_TYPE._values.push(this);
    }
}


// 閲覧者
export class VISITORS_RANGE extends CodeMasterInterface {
    protected static  _values: VISITORS_RANGE[] = [];

    /** 全て */
    static readonly ALL = new VISITORS_RANGE("0", "全て", 1);

    /** 所有者のみ */
    static readonly OWNER = new VISITORS_RANGE("1", "所有者のみ", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VISITORS_RANGE._values.push(this);
    }
}


// 規約同意タイプ
export class AGREEMENT_TYPE extends CodeMasterInterface {
    protected static  _values: AGREEMENT_TYPE[] = [];

    /** 同意しない */
    static readonly DISAGREE = new AGREEMENT_TYPE("0", "同意しない", 3);

    /** 素敵ネット/長谷工ID */
    static readonly SUTEKI_AND_HASOKO = new AGREEMENT_TYPE("1", "素敵ネット/長谷工ID", 1);

    /** 素敵ネット */
    static readonly SUTEKI = new AGREEMENT_TYPE("2", "素敵ネット", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        AGREEMENT_TYPE._values.push(this);
    }
}


// 施設予約遷移元画面
export class FACILITY_RESERVATION_TRANSITION_FROM extends CodeMasterInterface {
    protected static  _values: FACILITY_RESERVATION_TRANSITION_FROM[] = [];

    /** 予約TOP */
    static readonly RESERVE_TOP = new FACILITY_RESERVATION_TRANSITION_FROM("1", "予約TOP", 1);

    /** あなたの予約状況 */
    static readonly YOUR_RESERVATION_STATUS = new FACILITY_RESERVATION_TRANSITION_FROM("2", "あなたの予約状況", 2);

    /** 施設の予約状況 */
    static readonly FACILITY_RESERVATION_STATUS = new FACILITY_RESERVATION_TRANSITION_FROM("3", "施設の予約状況", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FACILITY_RESERVATION_TRANSITION_FROM._values.push(this);
    }
}


// 初回ログイン遷移元画面ID
export class FIRST_LOGIN_REFERRER_ID extends CodeMasterInterface {
    protected static  _values: FIRST_LOGIN_REFERRER_ID[] = [];

    /** ログイン */
    static readonly LOGIN = new FIRST_LOGIN_REFERRER_ID("1", "ログイン", 1);

    /** 規約同意 */
    static readonly POLICY_AGREE = new FIRST_LOGIN_REFERRER_ID("2", "規約同意", 2);

    /** 長谷工ID説明 */
    static readonly HASEKO_ID_DESCRIPTION = new FIRST_LOGIN_REFERRER_ID("3", "長谷工ID説明", 3);

    /** 認証キー入力 */
    static readonly AUTHENTICATION_KEY_INPUT = new FIRST_LOGIN_REFERRER_ID("4", "認証キー入力", 4);

    /** 長谷工ID確認 */
    static readonly HASEKO_ID_CONFIRM = new FIRST_LOGIN_REFERRER_ID("5", "長谷工ID確認", 5);

    /** 長谷工IDパスワード確認 */
    static readonly HASEKO_PASSWORD_CONFIRM = new FIRST_LOGIN_REFERRER_ID("6", "長谷工IDパスワード確認", 6);

    /** 素敵ネットIDパスワード確認 */
    static readonly SUTEKI_PASSWORD_CONFIRM = new FIRST_LOGIN_REFERRER_ID("7", "素敵ネットIDパスワード確認", 7);

    /** メールアドレス登録 */
    static readonly MAIL_ADDRESS_REGISTER = new FIRST_LOGIN_REFERRER_ID("8", "メールアドレス登録", 8);

    /** ユーザ情報入力 */
    static readonly USER_INFO_INPUT = new FIRST_LOGIN_REFERRER_ID("9", "ユーザ情報入力", 9);

    /** ユーザ情報入力確認 */
    static readonly USER_INFO_INPUT_CONFIRM = new FIRST_LOGIN_REFERRER_ID("10", "ユーザ情報入力確認", 10);

    /** FLP連携誘導 */
    static readonly FLP_LINK_GUIDE = new FIRST_LOGIN_REFERRER_ID("11", "FLP連携誘導", 11);

    /** 組合員資格変更届 */
    static readonly OWNERSHIP_TRANSFER = new FIRST_LOGIN_REFERRER_ID("12", "組合員資格変更届", 12);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FIRST_LOGIN_REFERRER_ID._values.push(this);
    }
}


// しないする
export class DO_OR_NOT extends CodeMasterInterface {
    protected static  _values: DO_OR_NOT[] = [];

    /** しない */
    static readonly NOT = new DO_OR_NOT("0", "しない", 1);

    /** する */
    static readonly DO = new DO_OR_NOT("1", "する", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DO_OR_NOT._values.push(this);
    }
}


// 情報種別
export class INFOMATION_TYPE extends CodeMasterInterface {
    protected static  _values: INFOMATION_TYPE[] = [];

    /** マンション情報 */
    static readonly APART_INFO = new INFOMATION_TYPE("0", "マンション情報", 1);

    /** 管理組合情報 */
    static readonly ASSOC_INFO = new INFOMATION_TYPE("1", "管理組合情報", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        INFOMATION_TYPE._values.push(this);
    }
}


// マンション情報カテゴリ
export class MANSION_CATEGORY extends CodeMasterInterface {
    protected static  _values: MANSION_CATEGORY[] = [];

    /** 生活のしおり */
    static readonly LIFE_BOOKMARK = new MANSION_CATEGORY("0", "生活のしおり", 1);

    /** 取扱説明書 */
    static readonly MANUAL = new MANSION_CATEGORY("1", "取扱説明書", 2);

    /** パンフレット図面 */
    static readonly BROCHURE_DRAWING = new MANSION_CATEGORY("2", "パンフレット図面", 3);

    /** 救急情報 */
    static readonly EMERGENCY_INFORMATION = new MANSION_CATEGORY("3", "救急情報", 4);

    /** 管理報告書 */
    static readonly MANAGEMENT_REPORT = new MANSION_CATEGORY("4", "管理報告書", 5);

    /** 自治会 */
    static readonly RESIDENTS_ASSOCIATION = new MANSION_CATEGORY("5", "自治会", 6);

    /** 自主防災検討会議 */
    static readonly DISASTER_PREVENTION = new MANSION_CATEGORY("6", "自主防災検討会議", 7);

    /** 店舗紹介 */
    static readonly STORE_DESCRIPTION = new MANSION_CATEGORY("7", "店舗紹介", 8);

    /** コミュニティ */
    static readonly COMMUNITY = new MANSION_CATEGORY("8", "コミュニティ", 9);

    /** 工事関係 */
    static readonly CONSTRUCTION_INFOMATION = new MANSION_CATEGORY("9", "工事関係", 10);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MANSION_CATEGORY._values.push(this);
    }
}


// 管理組合情報カテゴリ
export class MANAGEMENT_CATEGORY extends CodeMasterInterface {
    protected static  _values: MANAGEMENT_CATEGORY[] = [];

    /** 議事録 */
    static readonly CONFERENCE_NOTE = new MANAGEMENT_CATEGORY("0", "議事録", 1);

    /** 規約 */
    static readonly POLICY_AGREE = new MANAGEMENT_CATEGORY("1", "規約", 2);

    /** 各種届出書類 */
    static readonly PAPERWORK = new MANAGEMENT_CATEGORY("2", "各種届出書類", 3);

    /** 総会資料 */
    static readonly CONGRESS = new MANAGEMENT_CATEGORY("3", "総会資料", 4);

    /** その他 */
    static readonly OTHER = new MANAGEMENT_CATEGORY("4", "その他", 5);

    /** イベント報告 */
    static readonly EVENT = new MANAGEMENT_CATEGORY("5", "イベント報告", 6);

    /** 住宅履歴管理情報 */
    static readonly HOUSING_RECORD = new MANAGEMENT_CATEGORY("6", "住宅履歴管理情報", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MANAGEMENT_CATEGORY._values.push(this);
    }
}


// はいいいえ
export class YES_OR_NOT extends CodeMasterInterface {
    protected static  _values: YES_OR_NOT[] = [];

    /** はい */
    static readonly YES = new YES_OR_NOT("1", "はい", 1);

    /** いいえ */
    static readonly NO = new YES_OR_NOT("0", "いいえ", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        YES_OR_NOT._values.push(this);
    }
}


// メッセージカテゴリ
export class MESSAGE_CATEGORY extends CodeMasterInterface {
    protected static  _values: MESSAGE_CATEGORY[] = [];

    /** 運営者 */
    static readonly OPERATING_COMPANY = new MESSAGE_CATEGORY("0", "運営者", 7);

    /** 管理会社 */
    static readonly MANAGEMENT_COMPANY = new MESSAGE_CATEGORY("1", "管理会社", 1);

    /** 管理組合 */
    static readonly ASSOC = new MESSAGE_CATEGORY("2", "管理組合", 6);

    /** クラブ */
    static readonly CLUB = new MESSAGE_CATEGORY("3", "クラブ", 4);

    /** サークル */
    static readonly CIRCLE = new MESSAGE_CATEGORY("4", "サークル", 5);

    /** 委員会 */
    static readonly COMMITTEE = new MESSAGE_CATEGORY("5", "委員会", 2);

    /** 管理会社PR */
    static readonly MANAGEMENT_COMPANY_PR = new MESSAGE_CATEGORY("6", "管理会社PR", 8);

    /** 自治会 */
    static readonly RESIDENTS_ASSOCIATION = new MESSAGE_CATEGORY("7", "自治会", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MESSAGE_CATEGORY._values.push(this);
    }
}


// メッセージカテゴリ(階層レベル4向け)
export class MESSAGE_CATEGORY_FOR_LEVEL4 extends CodeMasterInterface {
    protected static  _values: MESSAGE_CATEGORY_FOR_LEVEL4[] = [];

    /** 管理会社 */
    static readonly MANAGEMENT_COMPANY = new MESSAGE_CATEGORY_FOR_LEVEL4("1", "管理会社", 1);

    /** 管理組合 */
    static readonly ASSOC = new MESSAGE_CATEGORY_FOR_LEVEL4("2", "管理組合", 2);

    /** クラブ */
    static readonly CLUB = new MESSAGE_CATEGORY_FOR_LEVEL4("3", "クラブ", 3);

    /** サークル */
    static readonly CIRCLE = new MESSAGE_CATEGORY_FOR_LEVEL4("4", "サークル", 4);

    /** 委員会 */
    static readonly COMMITTEE = new MESSAGE_CATEGORY_FOR_LEVEL4("5", "委員会", 5);

    /** 管理会社PR */
    static readonly MANAGEMENT_COMPANY_PR = new MESSAGE_CATEGORY_FOR_LEVEL4("6", "管理会社PR", 6);

    /** 自治会 */
    static readonly RESIDENTS_ASSOCIATION = new MESSAGE_CATEGORY_FOR_LEVEL4("7", "自治会", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MESSAGE_CATEGORY_FOR_LEVEL4._values.push(this);
    }
}


// メッセージカテゴリ(管理組合理事会向け)
export class MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION extends CodeMasterInterface {
    protected static  _values: MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION[] = [];

    /** 管理組合 */
    static readonly ASSOC = new MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION("2", "管理組合", 1);

    /** 自治会 */
    static readonly RESIDENTS_ASSOCIATION = new MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION("7", "自治会", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION._values.push(this);
    }
}


// メッセージ検索用カテゴリ(管理組合理事会向け)
export class MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION extends CodeMasterInterface {
    protected static  _values: MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION[] = [];

    /** 管理組合 */
    static readonly ASSOC = new MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION("2", "管理組合", 2);

    /** クラブ */
    static readonly CLUB = new MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION("3", "クラブ", 3);

    /** サークル */
    static readonly CIRCLE = new MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION("4", "サークル", 4);

    /** 委員会 */
    static readonly COMMITTEE = new MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION("5", "委員会", 5);

    /** 自治会 */
    static readonly RESIDENTS_ASSOCIATION = new MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION("7", "自治会", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION._values.push(this);
    }
}


// 月
export class MONTH extends CodeMasterInterface {
    protected static  _values: MONTH[] = [];

    /** 1 */
    static readonly VOL_1 = new MONTH("1", "1", 1);

    /** 2 */
    static readonly VOL_2 = new MONTH("2", "2", 2);

    /** 3 */
    static readonly VOL_3 = new MONTH("3", "3", 3);

    /** 4 */
    static readonly VOL_4 = new MONTH("4", "4", 4);

    /** 5 */
    static readonly VOL_5 = new MONTH("5", "5", 5);

    /** 6 */
    static readonly VOL_6 = new MONTH("6", "6", 6);

    /** 7 */
    static readonly VOL_7 = new MONTH("7", "7", 7);

    /** 8 */
    static readonly VOL_8 = new MONTH("8", "8", 8);

    /** 9 */
    static readonly VOL_9 = new MONTH("9", "9", 9);

    /** 10 */
    static readonly VOL_10 = new MONTH("10", "10", 10);

    /** 11 */
    static readonly VOL_11 = new MONTH("11", "11", 11);

    /** 12 */
    static readonly VOL_12 = new MONTH("12", "12", 12);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MONTH._values.push(this);
    }
}


// 表示種別（全体モード）
export class DISP_TYPE_ALL_MODE extends CodeMasterInterface {
    protected static  _values: DISP_TYPE_ALL_MODE[] = [];

    /** 便利リンク */
    static readonly LINK = new DISP_TYPE_ALL_MODE("0", "便利リンク", 1);

    /** 地域情報 */
    static readonly AREA_INFO = new DISP_TYPE_ALL_MODE("1", "地域情報", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISP_TYPE_ALL_MODE._values.push(this);
    }
}


// 表示種別（物件選択モード）
export class DISP_TYPE_ARTICLE_SELECT_MODE extends CodeMasterInterface {
    protected static  _values: DISP_TYPE_ARTICLE_SELECT_MODE[] = [];

    /** マンション情報(バナーあり) */
    static readonly BANNER = new DISP_TYPE_ARTICLE_SELECT_MODE("2", "マンション情報(バナーあり)", 1);

    /** マンション情報(バナーなし) */
    static readonly NO_BANNER = new DISP_TYPE_ARTICLE_SELECT_MODE("3", "マンション情報(バナーなし)", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISP_TYPE_ARTICLE_SELECT_MODE._values.push(this);
    }
}


// 生活便利帳カテゴリー
export class LIFE_CONVENIENT_BOOK_CATEGORY extends CodeMasterInterface {
    protected static  _values: LIFE_CONVENIENT_BOOK_CATEGORY[] = [];

    /** 行政 */
    static readonly GOVERNMENT = new LIFE_CONVENIENT_BOOK_CATEGORY("1", "行政", 1);

    /** くらし 生活 */
    static readonly LIFE = new LIFE_CONVENIENT_BOOK_CATEGORY("2", "くらし 生活", 2);

    /** お役立ち */
    static readonly VALUABLE = new LIFE_CONVENIENT_BOOK_CATEGORY("3", "お役立ち", 3);

    /** 防災 */
    static readonly DISASTER_PREVENTION = new LIFE_CONVENIENT_BOOK_CATEGORY("4", "防災", 4);

    /** その他 */
    static readonly OTHER = new LIFE_CONVENIENT_BOOK_CATEGORY("5", "その他", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        LIFE_CONVENIENT_BOOK_CATEGORY._values.push(this);
    }
}


// ファイル形式
export class FILE_FORMAT extends CodeMasterInterface {
    protected static  _values: FILE_FORMAT[] = [];

    /** CSV */
    static readonly CSV = new FILE_FORMAT("0", "CSV", 1);

    /** ZIP */
    static readonly ZIP = new FILE_FORMAT("1", "ZIP", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FILE_FORMAT._values.push(this);
    }
}


// 通知を受け取る受け取らない
export class NOTIFICATION_DO_OR_NOT extends CodeMasterInterface {
    protected static  _values: NOTIFICATION_DO_OR_NOT[] = [];

    /** 通知を受け取る */
    static readonly NOTICE = new NOTIFICATION_DO_OR_NOT("1", "通知を受け取る", 1);

    /** 通知を受け取らない */
    static readonly DO_NOT_NOTIFY = new NOTIFICATION_DO_OR_NOT("0", "通知を受け取らない", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        NOTIFICATION_DO_OR_NOT._values.push(this);
    }
}


// メールマガジンを受け取る受け取らない
export class MAIL_MAGAZINE_RECEIVING_DO_OR_NOT extends CodeMasterInterface {
    protected static  _values: MAIL_MAGAZINE_RECEIVING_DO_OR_NOT[] = [];

    /** メールマガジンを受け取る */
    static readonly NOTICE = new MAIL_MAGAZINE_RECEIVING_DO_OR_NOT("1", "メールマガジンを受け取る", 1);

    /** メールマガジンを受け取らない */
    static readonly DO_NOT_NOTIFY = new MAIL_MAGAZINE_RECEIVING_DO_OR_NOT("0", "メールマガジンを受け取らない", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MAIL_MAGAZINE_RECEIVING_DO_OR_NOT._values.push(this);
    }
}


// 掲載状態
export class PUBLICATION_STATUS extends CodeMasterInterface {
    protected static  _values: PUBLICATION_STATUS[] = [];

    /** 掲載前 */
    static readonly BEFORE_PUBLICATION = new PUBLICATION_STATUS("1", "掲載前", 1);

    /** 掲載中 */
    static readonly BEING_PUBLISHED = new PUBLICATION_STATUS("2", "掲載中", 2);

    /** 終了 */
    static readonly POSTING_END = new PUBLICATION_STATUS("3", "終了", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PUBLICATION_STATUS._values.push(this);
    }
}


// 必須（チェック）
export class REQUIRED_CHECK extends CodeMasterInterface {
    protected static  _values: REQUIRED_CHECK[] = [];

    /** － */
    static readonly ELECTIVE = new REQUIRED_CHECK("0", "－", 1);

    /** ✓ */
    static readonly REQUIRED = new REQUIRED_CHECK("1", "✓", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        REQUIRED_CHECK._values.push(this);
    }
}


// 表示しないする
export class VIEW_DO_OR_NOT extends CodeMasterInterface {
    protected static  _values: VIEW_DO_OR_NOT[] = [];

    /** 表示する */
    static readonly DISPLAY = new VIEW_DO_OR_NOT("0", "表示する", 1);

    /** 表示しない */
    static readonly HIDDEN = new VIEW_DO_OR_NOT("1", "表示しない", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VIEW_DO_OR_NOT._values.push(this);
    }
}


// 登録単位
export class REGISTRATION_UNIT extends CodeMasterInterface {
    protected static  _values: REGISTRATION_UNIT[] = [];

    /** 個別登録 */
    static readonly INDIVIDUAL = new REGISTRATION_UNIT("1", "個別登録", 1);

    /** 一括登録 */
    static readonly BULK = new REGISTRATION_UNIT("2", "一括登録", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        REGISTRATION_UNIT._values.push(this);
    }
}


// スレッドカテゴリ
export class THREAD_CATEGORY extends CodeMasterInterface {
    protected static  _values: THREAD_CATEGORY[] = [];

    /** 居住者専用 */
    static readonly RESIDENT = new THREAD_CATEGORY("0", "居住者専用", 1);

    /** 管理組合専用 */
    static readonly ADMIN = new THREAD_CATEGORY("1", "管理組合専用", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        THREAD_CATEGORY._values.push(this);
    }
}


// 抽選処理ステータス
export class LOTTERY_PROCESSING_STATUS extends CodeMasterInterface {
    protected static  _values: LOTTERY_PROCESSING_STATUS[] = [];

    /** 抽選中 */
    static readonly PROCESSING = new LOTTERY_PROCESSING_STATUS("0", "抽選中", 1);

    /** 抽選完了 */
    static readonly COMPLETE = new LOTTERY_PROCESSING_STATUS("9", "抽選完了", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        LOTTERY_PROCESSING_STATUS._values.push(this);
    }
}


// スレッド優先度
export class THREAD_PRIORITY extends CodeMasterInterface {
    protected static  _values: THREAD_PRIORITY[] = [];

    /** 普通 */
    static readonly NORMAL = new THREAD_PRIORITY("0", "普通", 1);

    /** 優先 */
    static readonly IMPORTANT = new THREAD_PRIORITY("1", "優先", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        THREAD_PRIORITY._values.push(this);
    }
}


// スレッド検索条件
export class THREAD_SEARCH extends CodeMasterInterface {
    protected static  _values: THREAD_SEARCH[] = [];

    /** 自分のスレッドのみ */
    static readonly MY_THREAD = new THREAD_SEARCH("0", "自分のスレッドのみ", 1);

    /** 返信が多い */
    static readonly MANY_REPLIES = new THREAD_SEARCH("1", "返信が多い", 2);

    /** 返信が少ない */
    static readonly FEW_REPLIES = new THREAD_SEARCH("2", "返信が少ない", 3);

    /** 更新日時が新しい */
    static readonly LATEST = new THREAD_SEARCH("3", "更新日時が新しい", 4);

    /** 更新日時が古い */
    static readonly OLDEST = new THREAD_SEARCH("4", "更新日時が古い", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        THREAD_SEARCH._values.push(this);
    }
}


// 個人情報操作種別
export class PERSONAL_INFO_OPERATION_TYPE extends CodeMasterInterface {
    protected static  _values: PERSONAL_INFO_OPERATION_TYPE[] = [];

    /** 印刷 */
    static readonly PRINT = new PERSONAL_INFO_OPERATION_TYPE("1", "印刷", 1);

    /** エクスポート */
    static readonly EXPORT = new PERSONAL_INFO_OPERATION_TYPE("2", "エクスポート", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PERSONAL_INFO_OPERATION_TYPE._values.push(this);
    }
}


// メッセージタイプ
export class MESSAGE_TYPE extends CodeMasterInterface {
    protected static  _values: MESSAGE_TYPE[] = [];

    /** information */
    static readonly INFORMATION = new MESSAGE_TYPE("1", "information", 1);

    /** warning */
    static readonly WARNING = new MESSAGE_TYPE("2", "warning", 2);

    /** critical */
    static readonly CRITICAL = new MESSAGE_TYPE("3", "critical", 3);

    /** error */
    static readonly ERROR = new MESSAGE_TYPE("4", "error", 4);

    /** nothing */
    static readonly NOTHING = new MESSAGE_TYPE("-1", "nothing", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MESSAGE_TYPE._values.push(this);
    }
}


// 外部API結果コード
export class EXTERNAL_API_RESULT_CODE extends CodeMasterInterface {
    protected static  _values: EXTERNAL_API_RESULT_CODE[] = [];

    /** 成功 */
    static readonly SUCCESS = new EXTERNAL_API_RESULT_CODE("00", "成功", 1);

    /** 警告 */
    static readonly WARN = new EXTERNAL_API_RESULT_CODE("10", "警告", 2);

    /** リクエストパラメータの構造エラー */
    static readonly FORMAT_ERROR = new EXTERNAL_API_RESULT_CODE("20", "リクエストパラメータの構造エラー", 3);

    /** 入力値エラー */
    static readonly INPUT_ERROR = new EXTERNAL_API_RESULT_CODE("30", "入力値エラー", 4);

    /** 内部エラー */
    static readonly INTERNAL_ERROR = new EXTERNAL_API_RESULT_CODE("99", "内部エラー", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EXTERNAL_API_RESULT_CODE._values.push(this);
    }
}


// 物件選択種別
export class SELECT_CONDOMINIUM_TYPE extends CodeMasterInterface {
    protected static  _values: SELECT_CONDOMINIUM_TYPE[] = [];

    /** 物件を選択する */
    static readonly CONDOMINIUM = new SELECT_CONDOMINIUM_TYPE("0", "物件を選択する", 1);

    /** 除外物件を選択する */
    static readonly EXCLUDE_CONDOMINIUM = new SELECT_CONDOMINIUM_TYPE("1", "除外物件を選択する", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SELECT_CONDOMINIUM_TYPE._values.push(this);
    }
}


// ユーザ選択種別
export class SELECT_USER_TYPE extends CodeMasterInterface {
    protected static  _values: SELECT_USER_TYPE[] = [];

    /** ユーザを選択する */
    static readonly USER = new SELECT_USER_TYPE("0", "ユーザを選択する", 1);

    /** 同時入室番号を選択する */
    static readonly ROOM_NUMBER = new SELECT_USER_TYPE("1", "同時入室番号を選択する", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SELECT_USER_TYPE._values.push(this);
    }
}


// ログインモード
export class LOGIN_MODE extends CodeMasterInterface {
    protected static  _values: LOGIN_MODE[] = [];

    /** 居住者 */
    static readonly RESIDENT = new LOGIN_MODE("0", "居住者", 1);

    /** 管理者 */
    static readonly ADMIN = new LOGIN_MODE("1", "管理者", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        LOGIN_MODE._values.push(this);
    }
}


// ロール区分
export class ROLE_TYPE extends CodeMasterInterface {
    protected static  _values: ROLE_TYPE[] = [];

    /** 管理者ロール */
    static readonly ADMIN = new ROLE_TYPE("A", "管理者ロール", 1);

    /** 居住者ロール */
    static readonly RESIDENT = new ROLE_TYPE("R", "居住者ロール", 2);

    /** ゲストロール */
    static readonly GUEST = new ROLE_TYPE("G", "ゲストロール", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ROLE_TYPE._values.push(this);
    }
}


// 管理者ロール
export class ROLE_FOR_ADMINISTRATOR extends CodeMasterInterface {
    protected static  _values: ROLE_FOR_ADMINISTRATOR[] = [];

    /** システム運用スタッフ */
    static readonly SYSTEM_ADMIN = new ROLE_FOR_ADMINISTRATOR("A01", "システム運用スタッフ", 1);

    /** コールセンター */
    static readonly CALL_CENTER = new ROLE_FOR_ADMINISTRATOR("A02", "コールセンター", 2);

    /** フロントスタッフ */
    static readonly FRONT_STAFF = new ROLE_FOR_ADMINISTRATOR("A03", "フロントスタッフ", 3);

    /** 事務センター（重調担当） */
    static readonly OFFICE_CENTER_OWNERSHIP_TRANSFER = new ROLE_FOR_ADMINISTRATOR("A09", "事務センター（重調担当）", 4);

    /** ライフマネージャ */
    static readonly LIFE_MANAGER = new ROLE_FOR_ADMINISTRATOR("A04", "ライフマネージャ", 5);

    /** コンシェルジュ */
    static readonly CONCIERGE = new ROLE_FOR_ADMINISTRATOR("A05", "コンシェルジュ", 6);

    /** 管理組合役員 */
    static readonly ASSOC = new ROLE_FOR_ADMINISTRATOR("A06", "管理組合役員", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ROLE_FOR_ADMINISTRATOR._values.push(this);
    }
}


// 居住者ロール
export class ROLE_FOR_RESIDENT extends CodeMasterInterface {
    protected static  _values: ROLE_FOR_RESIDENT[] = [];

    /** 内部所有者 */
    static readonly RESIDENT = new ROLE_FOR_RESIDENT("R01", "内部所有者", 1);

    /** 占有者 */
    static readonly APPROPRIATOR = new ROLE_FOR_RESIDENT("R02", "占有者", 2);

    /** 外部所有者 */
    static readonly OWNER = new ROLE_FOR_RESIDENT("R03", "外部所有者", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ROLE_FOR_RESIDENT._values.push(this);
    }
}


// 居住者ロール（内部）
export class ROLE_FOR_RESIDENT_REAL extends CodeMasterInterface {
    protected static  _values: ROLE_FOR_RESIDENT_REAL[] = [];

    /** 内部所有者 */
    static readonly RESIDENT = new ROLE_FOR_RESIDENT_REAL("R01", "内部所有者", 1);

    /** 占有者 */
    static readonly APPROPRIATOR = new ROLE_FOR_RESIDENT_REAL("R02", "占有者", 2);

    /** 外部所有者 */
    static readonly OWNER = new ROLE_FOR_RESIDENT_REAL("R03", "外部所有者", 3);

    /** 管理組合役員 */
    static readonly ASSOC = new ROLE_FOR_RESIDENT_REAL("R04", "管理組合役員", 4);

    /** 有効期間前 */
    static readonly BEFORE_OCCUPANCY = new ROLE_FOR_RESIDENT_REAL("R05", "有効期間前", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ROLE_FOR_RESIDENT_REAL._values.push(this);
    }
}


// ゲストロール
export class ROLE_FOR_GUEST extends CodeMasterInterface {
    protected static  _values: ROLE_FOR_GUEST[] = [];

    /** 仲介業者 */
    static readonly INTERMEDIARY = new ROLE_FOR_GUEST("G01", "仲介業者", 1);

    /** 旧組合員 */
    static readonly OLD_MEMBER = new ROLE_FOR_GUEST("G02", "旧組合員", 2);

    /** 新組合員 */
    static readonly NEW_MEMBER = new ROLE_FOR_GUEST("G03", "新組合員", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ROLE_FOR_GUEST._values.push(this);
    }
}


// 施設カテゴリ
export class FACILITY_CATEGORY extends CodeMasterInterface {
    protected static  _values: FACILITY_CATEGORY[] = [];

    /** 駐車場・洗車スペース */
    static readonly GUEST_PARKING_CARWASH = new FACILITY_CATEGORY("1", "駐車場・洗車スペース", 1);

    /** ゲストルーム */
    static readonly GUEST_ROOM = new FACILITY_CATEGORY("2", "ゲストルーム", 2);

    /** レンタサイクル */
    static readonly CYCLING = new FACILITY_CATEGORY("3", "レンタサイクル", 3);

    /** その他 */
    static readonly OTHER = new FACILITY_CATEGORY("4", "その他", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        FACILITY_CATEGORY._values.push(this);
    }
}


// 選択未選択
export class SELECT_OR_NOT extends CodeMasterInterface {
    protected static  _values: SELECT_OR_NOT[] = [];

    /** 選択 */
    static readonly SELECT = new SELECT_OR_NOT("True", "選択", 1);

    /** 未選択 */
    static readonly UNSELECTED = new SELECT_OR_NOT("False", "未選択", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SELECT_OR_NOT._values.push(this);
    }
}


// 管理画面モード
export class ADMINISTORATOR_MODE extends CodeMasterInterface {
    protected static  _values: ADMINISTORATOR_MODE[] = [];

    /** 全体モード */
    static readonly ALL = new ADMINISTORATOR_MODE("ALL", "全体モード", 1);

    /** 物件選択モード */
    static readonly CONDOMINIUM = new ADMINISTORATOR_MODE("CONDOMINIUM", "物件選択モード", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ADMINISTORATOR_MODE._values.push(this);
    }
}


// メニュー表示対象モード
export class MENU_MODE extends CodeMasterInterface {
    protected static  _values: MENU_MODE[] = [];

    /** 管理画面（物件選択モード） */
    static readonly ADMIN_CONDOMINIUM = new MENU_MODE("1", "管理画面（物件選択モード）", 1);

    /** 管理画面（全体モード） */
    static readonly ADMIN_ALL = new MENU_MODE("2", "管理画面（全体モード）", 2);

    /** 管理画面（共通） */
    static readonly ADMIN_COMMON = new MENU_MODE("3", "管理画面（共通）", 3);

    /** 居住者画面（共通） */
    static readonly RESIDENT_COMMON = new MENU_MODE("4", "居住者画面（共通）", 4);

    /** 居住者画面（居住者のみ） */
    static readonly RESIDENT_USER_ONLY = new MENU_MODE("5", "居住者画面（居住者のみ）", 5);

    /** 居住者画面（理事のみ） */
    static readonly RESIDENT_ASSOC_DIRECTOR_ONLY = new MENU_MODE("6", "居住者画面（理事のみ）", 6);

    /** 居住者画面（有効期間内のみ） */
    static readonly RESIDENT_IN_VALID_PERIOD_ONLY = new MENU_MODE("7", "居住者画面（有効期間内のみ）", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MENU_MODE._values.push(this);
    }
}


// イベント期間指定種別
export class EVENT_TERM_TYPE extends CodeMasterInterface {
    protected static  _values: EVENT_TERM_TYPE[] = [];

    /** 単日指定 */
    static readonly ONE_DAY = new EVENT_TERM_TYPE("1", "単日指定", 1);

    /** 期間指定 */
    static readonly TERM = new EVENT_TERM_TYPE("2", "期間指定", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EVENT_TERM_TYPE._values.push(this);
    }
}


// メールアドレス区分フラグ
export class MAIL_ADDRESS_TYPE extends CodeMasterInterface {
    protected static  _values: MAIL_ADDRESS_TYPE[] = [];

    /** PCメールアドレス */
    static readonly PC = new MAIL_ADDRESS_TYPE("1", "PCメールアドレス", 1);

    /** 携帯メールアドレス */
    static readonly MOBILE = new MAIL_ADDRESS_TYPE("2", "携帯メールアドレス", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MAIL_ADDRESS_TYPE._values.push(this);
    }
}


// 管理組合役員フラグ
export class ASSOC_DIRECTOR_FLAG extends CodeMasterInterface {
    protected static  _values: ASSOC_DIRECTOR_FLAG[] = [];

    /** 管理組合役員ではない */
    static readonly FALSE = new ASSOC_DIRECTOR_FLAG("0", "管理組合役員ではない", 1);

    /** 管理組合役員 */
    static readonly TRUE = new ASSOC_DIRECTOR_FLAG("1", "管理組合役員", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ASSOC_DIRECTOR_FLAG._values.push(this);
    }
}


// キャンセル理由
export class CANCEL_REASON extends CodeMasterInterface {
    protected static  _values: CANCEL_REASON[] = [];

    /** 休館 */
    static readonly CLOSE_SETTING = new CANCEL_REASON("1", "休館", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CANCEL_REASON._values.push(this);
    }
}


// 認証キー通知状発行申請ステータス
export class APPLY_STATUS extends CodeMasterInterface {
    protected static  _values: APPLY_STATUS[] = [];

    /** 申請前 */
    static readonly BEFORE_APPLY = new APPLY_STATUS("0", "申請前", 1);

    /** 申請中 */
    static readonly APPLYING = new APPLY_STATUS("1", "申請中", 2);

    /** 発行可能 */
    static readonly POSSIBLE = new APPLY_STATUS("2", "発行可能", 3);

    /** 発行済 */
    static readonly DONE = new APPLY_STATUS("3", "発行済", 4);

    /** 却下 */
    static readonly REJECTION = new APPLY_STATUS("4", "却下", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        APPLY_STATUS._values.push(this);
    }
}


// 確認ステータス
export class CONFIRMATION_STATUS extends CodeMasterInterface {
    protected static  _values: CONFIRMATION_STATUS[] = [];

    /** 未確認 */
    static readonly UNCONFIRMED = new CONFIRMATION_STATUS("0", "未確認", 1);

    /** 確認済 */
    static readonly CONFIRMED = new CONFIRMATION_STATUS("1", "確認済", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CONFIRMATION_STATUS._values.push(this);
    }
}


// 請求締め日
export class BILLING_DEADLINE extends CodeMasterInterface {
    protected static  _values: BILLING_DEADLINE[] = [];

    /** 15 */
    static readonly VOL_15 = new BILLING_DEADLINE("15", "15", 1);

    /** 20 */
    static readonly VOL_20 = new BILLING_DEADLINE("20", "20", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        BILLING_DEADLINE._values.push(this);
    }
}


// 抽出カテゴリ
export class EXTRACT_CATEGORY extends CodeMasterInterface {
    protected static  _values: EXTRACT_CATEGORY[] = [];

    /** 居住者ユーザリスト */
    static readonly RESIDENT_USER_LIST = new EXTRACT_CATEGORY("1", "居住者ユーザリスト", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EXTRACT_CATEGORY._values.push(this);
    }
}


// 抽出ステータス
export class EXTRACT_STATUS extends CodeMasterInterface {
    protected static  _values: EXTRACT_STATUS[] = [];

    /** 抽出要求 */
    static readonly REQUEST = new EXTRACT_STATUS("0", "抽出要求", 1);

    /** 抽出中 */
    static readonly PROCESSING = new EXTRACT_STATUS("1", "抽出中", 2);

    /** 抽出済 */
    static readonly DONE = new EXTRACT_STATUS("2", "抽出済", 3);

    /** 抽出失敗 */
    static readonly FAILED = new EXTRACT_STATUS("99", "抽出失敗", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        EXTRACT_STATUS._values.push(this);
    }
}


// 利用機能ID
export class USE_FUNCTION_ID extends CodeMasterInterface {
    protected static  _values: USE_FUNCTION_ID[] = [];

    /** 施設管理 */
    static readonly FACILITY = new USE_FUNCTION_ID("13", "施設管理", 13);

    /** メッセージ管理 */
    static readonly MESSAGE = new USE_FUNCTION_ID("15", "メッセージ管理", 15);

    /** カレンダー管理 */
    static readonly CALENDAR = new USE_FUNCTION_ID("16", "カレンダー管理", 16);

    /** 生活便利帳管理 */
    static readonly LIFE_NOTE = new USE_FUNCTION_ID("17", "生活便利帳管理", 17);

    /** 情報交換掲示板管理 */
    static readonly BULLETIN_BOARD = new USE_FUNCTION_ID("21", "情報交換掲示板管理", 21);

    /** わくわくメンテナンス */
    static readonly MAINTENANCE = new USE_FUNCTION_ID("24", "わくわくメンテナンス", 24);

    /** CASYS連携 */
    static readonly SYSTEM_CASYS = new USE_FUNCTION_ID("31", "CASYS連携", 31);

    /** smooth-e連携 */
    static readonly SMOOTH_E = new USE_FUNCTION_ID("32", "smooth-e連携", 32);

    /** コミュニケーションプラットフォーム連携 */
    static readonly COMMUNICATION_PLATFORM = new USE_FUNCTION_ID("33", "コミュニケーションプラットフォーム連携", 33);

    /** 理事会 */
    static readonly ASSOC_DIRECTOR = new USE_FUNCTION_ID("34", "理事会", 34);

    /** Web口座振替申請 */
    static readonly WEB_ACCOUNT_TRANSFER = new USE_FUNCTION_ID("35", "Web口座振替申請", 35);

    /** 住まいレージポイントサービス */
    static readonly SMILEAGE_POINT_SERVICE = new USE_FUNCTION_ID("36", "住まいレージポイントサービス", 36);

    /** 申請 */
    static readonly APPLICATION = new USE_FUNCTION_ID("37", "申請", 37);

    /** 緊急時連絡表 */
    static readonly CONTACT_ADDRESS_EMERGENCY = new USE_FUNCTION_ID("38", "緊急時連絡表", 38);

    /** 駐車場使用申込 */
    static readonly PARKING_USE_APPLICATION = new USE_FUNCTION_ID("39", "駐車場使用申込", 39);

    /** 駐車場使用契約解約届 */
    static readonly PARKING_WITHDRAWAL_APPLICATION = new USE_FUNCTION_ID("40", "駐車場使用契約解約届", 40);

    /** 自動車変更届 */
    static readonly CAR_CHANGE_NOTIFICATION = new USE_FUNCTION_ID("41", "自動車変更届", 41);

    /** 自転車置場使用申請 */
    static readonly BICYCLE_PARKING_USE_APPLICATION = new USE_FUNCTION_ID("42", "自転車置場使用申請", 42);

    /** 自転車置場使用許可解除届 */
    static readonly BICYCLE_PARKING_WITHDRAWAL_APPLICATION = new USE_FUNCTION_ID("43", "自転車置場使用許可解除届", 43);

    /** バイク置場使用申込 */
    static readonly BIKE_PARKING_USE_APPLICATION = new USE_FUNCTION_ID("44", "バイク置場使用申込", 44);

    /** バイク置場使用契約解約届 */
    static readonly BIKE_PARKING_WITHDRAWAL_APPLICATION = new USE_FUNCTION_ID("45", "バイク置場使用契約解約届", 45);

    /** バイク変更届 */
    static readonly BIKE_CHANGE_NOTIFICATION = new USE_FUNCTION_ID("46", "バイク変更届", 46);

    /** ペット飼育申請 */
    static readonly PET_BREEDING_APPLICATION = new USE_FUNCTION_ID("47", "ペット飼育申請", 47);

    /** 健康診断報告書 */
    static readonly PET_MEDICAL_CHECK_UP_REPORT = new USE_FUNCTION_ID("48", "健康診断報告書", 48);

    /** ペット飼育中止届 */
    static readonly PET_BREEDING_STOP = new USE_FUNCTION_ID("49", "ペット飼育中止届", 49);

    /** 工事申請書 */
    static readonly CONSTRUCTION_APPLICATION = new USE_FUNCTION_ID("50", "工事申請書", 50);

    /** 工事完了届 */
    static readonly CONSTRUCTION_COMPLETE_NOTIFICATION = new USE_FUNCTION_ID("51", "工事完了届", 51);

    /** 窓ガラスフィルム貼付申請 */
    static readonly WINDOW_GLASS_FILM_PASTE_NOTIFICATION = new USE_FUNCTION_ID("52", "窓ガラスフィルム貼付申請", 52);

    /** 長期不在届 */
    static readonly LONG_TERM_ABSENCE_NOTIFICATION = new USE_FUNCTION_ID("53", "長期不在届", 53);

    /** 重量物搬入等届 */
    static readonly HEAVY_LOADS_CARRY_IN_NOTIFICATION = new USE_FUNCTION_ID("54", "重量物搬入等届", 54);

    /** 閲覧申請書 */
    static readonly BROWSE_APPLICATION = new USE_FUNCTION_ID("55", "閲覧申請書", 55);

    /** 組合員資格変更届 */
    static readonly OWNERSHIP_TRANSFER = new USE_FUNCTION_ID("58", "組合員資格変更届", 58);

    /** 口座振替 */
    static readonly ACCOUNT_TRANSFER = new USE_FUNCTION_ID("61", "口座振替", 61);

    /** 防災たすけあい */
    static readonly DISASTER = new USE_FUNCTION_ID("64", "防災たすけあい", 64);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        USE_FUNCTION_ID._values.push(this);
    }
}


// 掲示板権限
export class BOARD_AUTHORITY extends CodeMasterInterface {
    protected static  _values: BOARD_AUTHORITY[] = [];

    /** 権限なし */
    static readonly NONE = new BOARD_AUTHORITY("0", "権限なし", 1);

    /** 参照 */
    static readonly VIEW = new BOARD_AUTHORITY("1", "参照", 2);

    /** 参照/編集 */
    static readonly EDIT = new BOARD_AUTHORITY("2", "参照/編集", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        BOARD_AUTHORITY._values.push(this);
    }
}


// 詳細検索条件
export class DETAIL_SEARCH_CONDITION extends CodeMasterInterface {
    protected static  _values: DETAIL_SEARCH_CONDITION[] = [];

    /** 指定なし */
    static readonly NO_CONDITION = new DETAIL_SEARCH_CONDITION("0", "指定なし", 1);

    /** 請求状況 */
    static readonly BILLING_STATUS = new DETAIL_SEARCH_CONDITION("1", "請求状況", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DETAIL_SEARCH_CONDITION._values.push(this);
    }
}


// 対象年月
export class TARGET_YEAR_MONTH extends CodeMasterInterface {
    protected static  _values: TARGET_YEAR_MONTH[] = [];

    /** 当月 */
    static readonly THIS_YEAR_MONTH = new TARGET_YEAR_MONTH("0", "当月", 1);

    /** 指定月 */
    static readonly ELECTED_YEAR_MONTH = new TARGET_YEAR_MONTH("1", "指定月", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        TARGET_YEAR_MONTH._values.push(this);
    }
}


// 公開開始時
export class RELEASE_START_HOURS extends CodeMasterInterface {
    protected static  _values: RELEASE_START_HOURS[] = [];

    /** 8 */
    static readonly VOL_8 = new RELEASE_START_HOURS("8", "8", 9);

    /** 9 */
    static readonly VOL_9 = new RELEASE_START_HOURS("9", "9", 10);

    /** 10 */
    static readonly VOL_10 = new RELEASE_START_HOURS("10", "10", 11);

    /** 11 */
    static readonly VOL_11 = new RELEASE_START_HOURS("11", "11", 12);

    /** 12 */
    static readonly VOL_12 = new RELEASE_START_HOURS("12", "12", 13);

    /** 13 */
    static readonly VOL_13 = new RELEASE_START_HOURS("13", "13", 14);

    /** 14 */
    static readonly VOL_14 = new RELEASE_START_HOURS("14", "14", 15);

    /** 15 */
    static readonly VOL_15 = new RELEASE_START_HOURS("15", "15", 16);

    /** 16 */
    static readonly VOL_16 = new RELEASE_START_HOURS("16", "16", 17);

    /** 17 */
    static readonly VOL_17 = new RELEASE_START_HOURS("17", "17", 18);

    /** 18 */
    static readonly VOL_18 = new RELEASE_START_HOURS("18", "18", 19);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RELEASE_START_HOURS._values.push(this);
    }
}


// 申請カテゴリ
export class APPLY_CATEGORY extends CodeMasterInterface {
    protected static  _values: APPLY_CATEGORY[] = [];

    /** 居住者ユーザ登録 */
    static readonly RESIDENT_USER_REGISTRATION = new APPLY_CATEGORY("1", "居住者ユーザ登録", 1);

    /** Web口座振替申請 */
    static readonly WEB_ACCOUNT_TRANSFER_APPLY = new APPLY_CATEGORY("2", "Web口座振替申請", 2);

    /** 緊急時連絡表 */
    static readonly CONTACT_ADDRESS_ON_EMERGENCY = new APPLY_CATEGORY("3", "緊急時連絡表", 3);

    /** 駐車場使用申込 */
    static readonly PARKING_USE_APPLY = new APPLY_CATEGORY("4", "駐車場使用申込", 4);

    /** 駐車場使用契約解約届 */
    static readonly PARKING_USE_CANCEL = new APPLY_CATEGORY("5", "駐車場使用契約解約届", 5);

    /** 自動車変更届 */
    static readonly CAR_CHANGE = new APPLY_CATEGORY("6", "自動車変更届", 6);

    /** 自転車置場使用申請 */
    static readonly BICYCLE_PARKING_USE_APPLY = new APPLY_CATEGORY("7", "自転車置場使用申請", 7);

    /** 自転車置場使用許可解除届 */
    static readonly BICYCLE_PARKING_USE_ADMIT_CANCEL = new APPLY_CATEGORY("8", "自転車置場使用許可解除届", 8);

    /** バイク置場使用申込 */
    static readonly BIKE_PARKING_USE_APPLY = new APPLY_CATEGORY("9", "バイク置場使用申込", 9);

    /** バイク置場使用契約解約届 */
    static readonly BIKE_PARKING_USE_ADMIT_CANCEL = new APPLY_CATEGORY("10", "バイク置場使用契約解約届", 10);

    /** バイク変更届 */
    static readonly BIKE_CHANGE = new APPLY_CATEGORY("11", "バイク変更届", 11);

    /** ペット飼育申請 */
    static readonly BREEDING_PETS_APPLY = new APPLY_CATEGORY("12", "ペット飼育申請", 12);

    /** 健康診断報告書 */
    static readonly MEDICAL_EXAMINATION_REPORT = new APPLY_CATEGORY("13", "健康診断報告書", 13);

    /** ペット飼育中止届 */
    static readonly BREEDING_PETS_CANCEL = new APPLY_CATEGORY("14", "ペット飼育中止届", 14);

    /** 工事申請書 */
    static readonly CONSTRUCTION_APPLY = new APPLY_CATEGORY("15", "工事申請書", 15);

    /** 工事完了届 */
    static readonly CONSTRUCTION_COMPLETION = new APPLY_CATEGORY("16", "工事完了届", 16);

    /** 窓ガラスフィルム貼付申請 */
    static readonly WINDOW_FILM_ATTACH_APPLY = new APPLY_CATEGORY("17", "窓ガラスフィルム貼付申請", 17);

    /** 長期不在届 */
    static readonly LONG_ABSENCE = new APPLY_CATEGORY("18", "長期不在届", 18);

    /** 重量物搬入等届 */
    static readonly HEAVY_GOODS_APPLY = new APPLY_CATEGORY("19", "重量物搬入等届", 19);

    /** 閲覧申請書 */
    static readonly INSPECTION_APPLY = new APPLY_CATEGORY("20", "閲覧申請書", 20);

    /** 組合員資格変更届 */
    static readonly OWNERSHIP_TRANSFER = new APPLY_CATEGORY("21", "組合員資格変更届", 21);

    /** 居住者ユーザ登録（居住者） */
    static readonly RESIDENT_USER_REGISTRATION_BY_RESIDENT = new APPLY_CATEGORY("22", "居住者ユーザ登録（居住者）", 22);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        APPLY_CATEGORY._values.push(this);
    }
}


// 居住者ユーザ登録申請ステータス
export class RESIDENT_USER_REGISTRATION_APPLY_STATUS extends CodeMasterInterface {
    protected static  _values: RESIDENT_USER_REGISTRATION_APPLY_STATUS[] = [];

    /** 申請中 */
    static readonly APPLYING = new RESIDENT_USER_REGISTRATION_APPLY_STATUS("0", "申請中", 1);

    /** 確認中 */
    static readonly CONFIRMING = new RESIDENT_USER_REGISTRATION_APPLY_STATUS("1", "確認中", 2);

    /** 承認済 */
    static readonly APPROVED = new RESIDENT_USER_REGISTRATION_APPLY_STATUS("2", "承認済", 3);

    /** 取消 */
    static readonly CANCEL = new RESIDENT_USER_REGISTRATION_APPLY_STATUS("3", "取消", 4);

    /** 却下 */
    static readonly REJECTION = new RESIDENT_USER_REGISTRATION_APPLY_STATUS("4", "却下", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_USER_REGISTRATION_APPLY_STATUS._values.push(this);
    }
}


// 居住者ユーザ登録申請区分
export class RESIDENT_USER_REGISTRATION_APPLY_CATEGORY extends CodeMasterInterface {
    protected static  _values: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY[] = [];

    /** 廃止申請 */
    static readonly ABOLITION = new RESIDENT_USER_REGISTRATION_APPLY_CATEGORY("0", "廃止申請", 2);

    /** 新規登録申請 */
    static readonly REGISTRATION = new RESIDENT_USER_REGISTRATION_APPLY_CATEGORY("1", "新規登録申請", 3);

    /** 廃止・新規登録申請 */
    static readonly ABOLITION_REGISTRATION = new RESIDENT_USER_REGISTRATION_APPLY_CATEGORY("2", "廃止・新規登録申請", 1);

    /** 通知状発行（再発行）申請 */
    static readonly NOTICE_REISSUE = new RESIDENT_USER_REGISTRATION_APPLY_CATEGORY("3", "通知状発行（再発行）申請", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_USER_REGISTRATION_APPLY_CATEGORY._values.push(this);
    }
}


// 配信コンテンツカテゴリ
export class DELIVERY_CONTENT_CATEGORY extends CodeMasterInterface {
    protected static  _values: DELIVERY_CONTENT_CATEGORY[] = [];

    /** 生活便利帳 */
    static readonly LIFE_NOTE = new DELIVERY_CONTENT_CATEGORY("0", "生活便利帳", 1);

    /** メッセージ */
    static readonly MESSAGE = new DELIVERY_CONTENT_CATEGORY("1", "メッセージ", 2);

    /** スケジュール */
    static readonly SCHEDULE = new DELIVERY_CONTENT_CATEGORY("2", "スケジュール", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DELIVERY_CONTENT_CATEGORY._values.push(this);
    }
}


// 出欠ステータス
export class ATTENDANCE_STATUS extends CodeMasterInterface {
    protected static  _values: ATTENDANCE_STATUS[] = [];

    /** 未回答 */
    static readonly UNANSWERED = new ATTENDANCE_STATUS("9", "未回答", 1);

    /** 出席 */
    static readonly ATTEND = new ATTENDANCE_STATUS("0", "出席", 2);

    /** 代理出席 */
    static readonly PROXY_ATTEND = new ATTENDANCE_STATUS("1", "代理出席", 3);

    /** 欠席 */
    static readonly ABSENT = new ATTENDANCE_STATUS("2", "欠席", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ATTENDANCE_STATUS._values.push(this);
    }
}


// 収納代行会社コード
export class RECEIVING_AGENCY_CD extends CodeMasterInterface {
    protected static  _values: RECEIVING_AGENCY_CD[] = [];

    /** りそな決済サービス */
    static readonly RESONA_KS = new RECEIVING_AGENCY_CD("1", "りそな決済サービス", 1);

    /** 三井住友カード */
    static readonly SMBC_CARD = new RECEIVING_AGENCY_CD("2", "三井住友カード", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RECEIVING_AGENCY_CD._values.push(this);
    }
}


// 組合会計部コード
export class ASSOC_ACCOUNTING_DEPT_CD extends CodeMasterInterface {
    protected static  _values: ASSOC_ACCOUNTING_DEPT_CD[] = [];

    /** 長谷工コミュニティ(東京) */
    static readonly HCM_TOKYO = new ASSOC_ACCOUNTING_DEPT_CD("1", "長谷工コミュニティ(東京)", 1);

    /** 長谷工コミュニティ(関西) */
    static readonly HCM_KANSAI = new ASSOC_ACCOUNTING_DEPT_CD("2", "長谷工コミュニティ(関西)", 2);

    /** 長谷工コミュニティ西日本 */
    static readonly HCM_NISHINIHON = new ASSOC_ACCOUNTING_DEPT_CD("3", "長谷工コミュニティ西日本", 3);

    /** 長谷工コミュニティ九州 */
    static readonly HCM_KYUSHU = new ASSOC_ACCOUNTING_DEPT_CD("4", "長谷工コミュニティ九州", 4);

    /** 長谷工コミュニティ沖縄 */
    static readonly HCM_OKINAWA = new ASSOC_ACCOUNTING_DEPT_CD("5", "長谷工コミュニティ沖縄", 5);

    /** その他 */
    static readonly ETC = new ASSOC_ACCOUNTING_DEPT_CD("99", "その他", 99);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ASSOC_ACCOUNTING_DEPT_CD._values.push(this);
    }
}


// 口座振替の処理の種類
export class ACCOUNT_TRANSFER_PROCESS extends CodeMasterInterface {
    protected static  _values: ACCOUNT_TRANSFER_PROCESS[] = [];

    /** 口座振替登録の申請を送信 */
    static readonly SEND = new ACCOUNT_TRANSFER_PROCESS("1", "口座振替登録の申請を送信", 1);

    /** 口座振替登録の申請結果を受信 */
    static readonly RECEIVED = new ACCOUNT_TRANSFER_PROCESS("2", "口座振替登録の申請結果を受信", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ACCOUNT_TRANSFER_PROCESS._values.push(this);
    }
}


// 時間貸し施設の日を跨いだ予約の数え方
export class DATE_STRADDLE_RESERVATION_COUNTING_METHOD extends CodeMasterInterface {
    protected static  _values: DATE_STRADDLE_RESERVATION_COUNTING_METHOD[] = [];

    /** １予約につき１回 */
    static readonly ONCE = new DATE_STRADDLE_RESERVATION_COUNTING_METHOD("1", "１予約につき１回", 1);

    /** １日につき１回 */
    static readonly PER_DAY = new DATE_STRADDLE_RESERVATION_COUNTING_METHOD("2", "１日につき１回", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DATE_STRADDLE_RESERVATION_COUNTING_METHOD._values.push(this);
    }
}


// 居住形態
export class RESIDENCE_STYLE extends CodeMasterInterface {
    protected static  _values: RESIDENCE_STYLE[] = [];

    /** 区分所有者 */
    static readonly UNIT_OWNER = new RESIDENCE_STYLE("1", "区分所有者", 1);

    /** 占有者・賃借人 */
    static readonly APPROPRIATOR_AND_TENANT = new RESIDENCE_STYLE("2", "占有者・賃借人", 2);

    /** 外部区分所有者 */
    static readonly EXTERNAL_UNIT_OWNER = new RESIDENCE_STYLE("3", "外部区分所有者", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENCE_STYLE._values.push(this);
    }
}


// 申請ステータス
export class RESIDENT_APPLY_STATUS extends CodeMasterInterface {
    protected static  _values: RESIDENT_APPLY_STATUS[] = [];

    /** 受付待ち */
    static readonly RECEPTION_WAITING = new RESIDENT_APPLY_STATUS("0", "受付待ち", 1);

    /** ペット委員長承認待ち */
    static readonly PET_CHAIRMAN_WAITING = new RESIDENT_APPLY_STATUS("1", "ペット委員長承認待ち", 2);

    /** 理事長承認待ち */
    static readonly ASSOC_DIRECTOR_WAITING = new RESIDENT_APPLY_STATUS("2", "理事長承認待ち", 3);

    /** 完了 */
    static readonly COMPLETE = new RESIDENT_APPLY_STATUS("8", "完了", 4);

    /** 却下 */
    static readonly REJECTION = new RESIDENT_APPLY_STATUS("9", "却下", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_APPLY_STATUS._values.push(this);
    }
}


// 申請工程
export class RESIDENT_APPLY_PROCESS extends CodeMasterInterface {
    protected static  _values: RESIDENT_APPLY_PROCESS[] = [];

    /** 申請 */
    static readonly APPLY = new RESIDENT_APPLY_PROCESS("0", "申請", 1);

    /** 受付 */
    static readonly RECEPTION = new RESIDENT_APPLY_PROCESS("1", "受付", 2);

    /** ペット委員長承認 */
    static readonly PET_CHAIRMAN_APPROVAL = new RESIDENT_APPLY_PROCESS("2", "ペット委員長承認", 3);

    /** 理事長承認 */
    static readonly ASSOC_DIRECTOR_APPROVAL = new RESIDENT_APPLY_PROCESS("3", "理事長承認", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_APPLY_PROCESS._values.push(this);
    }
}


// 申請イレギュラーパターン
export class APPLY_IRREGULAR_PATTERN extends CodeMasterInterface {
    protected static  _values: APPLY_IRREGULAR_PATTERN[] = [];

    /** 理事長承認代行操作 */
    static readonly ASSOC_DIRECTOR_DELEGATE_APPROVAL = new APPLY_IRREGULAR_PATTERN("1", "理事長承認代行操作", 1);

    /** ペットクラブなし */
    static readonly NO_PET_CLUB = new APPLY_IRREGULAR_PATTERN("2", "ペットクラブなし", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        APPLY_IRREGULAR_PATTERN._values.push(this);
    }
}


// 使用者属性
export class USER_ATTRIBUTE extends CodeMasterInterface {
    protected static  _values: USER_ATTRIBUTE[] = [];

    /** 組合員 */
    static readonly ASSOC = new USER_ATTRIBUTE("0", "組合員", 1);

    /** 組合員の同居人 */
    static readonly ASSOC_HOUSEMATE = new USER_ATTRIBUTE("1", "組合員の同居人", 2);

    /** 占有者 */
    static readonly APPROPRIATOR = new USER_ATTRIBUTE("2", "占有者", 3);

    /** 占有者の同居人 */
    static readonly APPROPRIATOR_HOUSEMATE = new USER_ATTRIBUTE("3", "占有者の同居人", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        USER_ATTRIBUTE._values.push(this);
    }
}


// ペット種類
export class PET_TYPE extends CodeMasterInterface {
    protected static  _values: PET_TYPE[] = [];

    /** 犬 */
    static readonly DOG = new PET_TYPE("1", "犬", 1);

    /** その他（猫、小動物） */
    static readonly OTHER_ANIMALS = new PET_TYPE("2", "その他（猫、小動物）", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PET_TYPE._values.push(this);
    }
}


// 滞在先種別
export class DESTINATION_TYPE extends CodeMasterInterface {
    protected static  _values: DESTINATION_TYPE[] = [];

    /** 国内 */
    static readonly DOMESTIC = new DESTINATION_TYPE("0", "国内", 1);

    /** 国外 */
    static readonly OVERSEA = new DESTINATION_TYPE("1", "国外", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DESTINATION_TYPE._values.push(this);
    }
}


// 管理組合役員グループ
export class ASSOC_GROUP extends CodeMasterInterface {
    protected static  _values: ASSOC_GROUP[] = [];

    /** 理事長 */
    static readonly ASSOC_CHAIRMAN = new ASSOC_GROUP("A07", "理事長", 1);

    /** 副理事長 */
    static readonly ASSOC_VICE_CHAIRMAN = new ASSOC_GROUP("A08", "副理事長", 2);

    /** その他 */
    static readonly ASSOC = new ASSOC_GROUP("A06", "その他", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ASSOC_GROUP._values.push(this);
    }
}


// 管理者ロール（内部）
export class ROLE_FOR_ADMINISTRATOR_REAL extends CodeMasterInterface {
    protected static  _values: ROLE_FOR_ADMINISTRATOR_REAL[] = [];

    /** システム運用スタッフ */
    static readonly SYSTEM_ADMIN = new ROLE_FOR_ADMINISTRATOR_REAL("A01", "システム運用スタッフ", 1);

    /** コールセンター */
    static readonly CALL_CENTER = new ROLE_FOR_ADMINISTRATOR_REAL("A02", "コールセンター", 2);

    /** フロントスタッフ */
    static readonly FRONT_STAFF = new ROLE_FOR_ADMINISTRATOR_REAL("A03", "フロントスタッフ", 3);

    /** 事務センター（重調担当） */
    static readonly OFFICE_CENTER_OWNERSHIP_TRANSFER = new ROLE_FOR_ADMINISTRATOR_REAL("A09", "事務センター（重調担当）", 4);

    /** ライフマネージャ */
    static readonly LIFE_MANAGER = new ROLE_FOR_ADMINISTRATOR_REAL("A04", "ライフマネージャ", 5);

    /** コンシェルジュ */
    static readonly CONCIERGE = new ROLE_FOR_ADMINISTRATOR_REAL("A05", "コンシェルジュ", 6);

    /** 管理組合役員 */
    static readonly ASSOC = new ROLE_FOR_ADMINISTRATOR_REAL("A06", "管理組合役員", 7);

    /** 理事長 */
    static readonly ASSOC_CHAIRMAN = new ROLE_FOR_ADMINISTRATOR_REAL("A07", "理事長", 8);

    /** 副理事長 */
    static readonly ASSOC_VICE_CHAIRMAN = new ROLE_FOR_ADMINISTRATOR_REAL("A08", "副理事長", 9);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ROLE_FOR_ADMINISTRATOR_REAL._values.push(this);
    }
}


// 申請分類
export class RESIDENT_APPLY_DIVISION extends CodeMasterInterface {
    protected static  _values: RESIDENT_APPLY_DIVISION[] = [];

    /** 連絡先 */
    static readonly CONTACT_ADDRESS = new RESIDENT_APPLY_DIVISION("2", "連絡先", 2);

    /** 車 */
    static readonly CAR = new RESIDENT_APPLY_DIVISION("3", "車", 3);

    /** 自転車・バイク */
    static readonly BICYCLE_BIKE = new RESIDENT_APPLY_DIVISION("4", "自転車・バイク", 4);

    /** ペット */
    static readonly PET = new RESIDENT_APPLY_DIVISION("5", "ペット", 5);

    /** 工事 */
    static readonly CONSTRUCTION = new RESIDENT_APPLY_DIVISION("6", "工事", 6);

    /** その他 */
    static readonly OTHER = new RESIDENT_APPLY_DIVISION("7", "その他", 7);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_APPLY_DIVISION._values.push(this);
    }
}


// 申請履歴分類
export class RESIDENT_APPLY_HISTORY_DIVISION extends CodeMasterInterface {
    protected static  _values: RESIDENT_APPLY_HISTORY_DIVISION[] = [];

    /** 承認待ち */
    static readonly APPROVAL_WAITING = new RESIDENT_APPLY_HISTORY_DIVISION("0", "承認待ち", 1);

    /** 承認済み */
    static readonly APPROVED = new RESIDENT_APPLY_HISTORY_DIVISION("1", "承認済み", 2);

    /** 却下 */
    static readonly REJECTION = new RESIDENT_APPLY_HISTORY_DIVISION("2", "却下", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_APPLY_HISTORY_DIVISION._values.push(this);
    }
}


// 希望しないする
export class HOPE_DO_OR_NOT extends CodeMasterInterface {
    protected static  _values: HOPE_DO_OR_NOT[] = [];

    /** 希望しない */
    static readonly NOT_HOPE = new HOPE_DO_OR_NOT("0", "希望しない", 1);

    /** 希望する */
    static readonly HOPE = new HOPE_DO_OR_NOT("1", "希望する", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        HOPE_DO_OR_NOT._values.push(this);
    }
}


// 変更タイプ
export class CHANGE_TYPE extends CodeMasterInterface {
    protected static  _values: CHANGE_TYPE[] = [];

    /** 一時変更 */
    static readonly TEMPORARY = new CHANGE_TYPE("0", "一時変更", 1);

    /** 恒久変更 */
    static readonly PERMANENT = new CHANGE_TYPE("1", "恒久変更", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CHANGE_TYPE._values.push(this);
    }
}


// 飼育中止理由
export class HAVE_PET_END_REASON extends CodeMasterInterface {
    protected static  _values: HAVE_PET_END_REASON[] = [];

    /** マンションからの転出 */
    static readonly MOVING_OUT = new HAVE_PET_END_REASON("0", "マンションからの転出", 1);

    /** ペットの他人への譲渡 */
    static readonly TRANSFER = new HAVE_PET_END_REASON("1", "ペットの他人への譲渡", 2);

    /** ペットの死亡 */
    static readonly PET_DEATH = new HAVE_PET_END_REASON("2", "ペットの死亡", 3);

    /** その他 */
    static readonly OTHER = new HAVE_PET_END_REASON("3", "その他", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        HAVE_PET_END_REASON._values.push(this);
    }
}


// 公開範囲
export class MONTHLY_REPORT_PUBLISHING_SCOPE extends CodeMasterInterface {
    protected static  _values: MONTHLY_REPORT_PUBLISHING_SCOPE[] = [];

    /** 理事長のみ */
    static readonly ASSOC_DIRECTOR = new MONTHLY_REPORT_PUBLISHING_SCOPE("1", "理事長のみ", 1);

    /** 役員 */
    static readonly ASSOC = new MONTHLY_REPORT_PUBLISHING_SCOPE("2", "役員", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        MONTHLY_REPORT_PUBLISHING_SCOPE._values.push(this);
    }
}


// 業務カテゴリ
export class BUSINESS_CATEGORY extends CodeMasterInterface {
    protected static  _values: BUSINESS_CATEGORY[] = [];

    /** 会計報告・管理業務月報 */
    static readonly ACCOUNTING_MONTHLY_REPORT = new BUSINESS_CATEGORY("10", "会計報告・管理業務月報", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        BUSINESS_CATEGORY._values.push(this);
    }
}


// 予定有無
export class PLAN_EXISTENCE extends CodeMasterInterface {
    protected static  _values: PLAN_EXISTENCE[] = [];

    /** 予定なし */
    static readonly NOT = new PLAN_EXISTENCE("0", "予定なし", 1);

    /** 予定あり */
    static readonly HAVE = new PLAN_EXISTENCE("1", "予定あり", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PLAN_EXISTENCE._values.push(this);
    }
}


// 施工依頼
export class CONTRACTOR_REQUEST extends CodeMasterInterface {
    protected static  _values: CONTRACTOR_REQUEST[] = [];

    /** 業者に依頼する */
    static readonly REQUEST = new CONTRACTOR_REQUEST("0", "業者に依頼する", 1);

    /** 業者に依頼しない（本人など） */
    static readonly NOT_REQUEST = new CONTRACTOR_REQUEST("1", "業者に依頼しない（本人など）", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        CONTRACTOR_REQUEST._values.push(this);
    }
}


// 対象対象外
export class TARGET_OR_NOT extends CodeMasterInterface {
    protected static  _values: TARGET_OR_NOT[] = [];

    /** 対象 */
    static readonly TARGET = new TARGET_OR_NOT("1", "対象", 1);

    /** 対象外 */
    static readonly NOT = new TARGET_OR_NOT("0", "対象外", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        TARGET_OR_NOT._values.push(this);
    }
}


// 組変ステータス
export class OWNERSHIP_TRANSFER_STATUS extends CodeMasterInterface {
    protected static  _values: OWNERSHIP_TRANSFER_STATUS[] = [];

    /** 発行済み */
    static readonly ISSUED = new OWNERSHIP_TRANSFER_STATUS("0", "発行済み", 1);

    /** 入力中 */
    static readonly INPUTTING = new OWNERSHIP_TRANSFER_STATUS("1", "入力中", 2);

    /** 提出完了 */
    static readonly COMPLETE = new OWNERSHIP_TRANSFER_STATUS("8", "提出完了", 3);

    /** 無効 */
    static readonly INVALID = new OWNERSHIP_TRANSFER_STATUS("9", "無効", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        OWNERSHIP_TRANSFER_STATUS._values.push(this);
    }
}


// 居住先
export class RESIDENT_PLACE extends CodeMasterInterface {
    protected static  _values: RESIDENT_PLACE[] = [];

    /** 住む */
    static readonly RESIDING = new RESIDENT_PLACE("0", "住む", 1);

    /** 住まない（国内に住む） */
    static readonly DOMESTIC = new RESIDENT_PLACE("1", "住まない（国内に住む）", 2);

    /** 住まない（海外に住む） */
    static readonly FOREIGN = new RESIDENT_PLACE("2", "住まない（海外に住む）", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESIDENT_PLACE._values.push(this);
    }
}


// 支払の有無
export class PAYMENT_EXISTENCE extends CodeMasterInterface {
    protected static  _values: PAYMENT_EXISTENCE[] = [];

    /** 本人が支払う */
    static readonly PRINCIPAL = new PAYMENT_EXISTENCE("0", "本人が支払う", 1);

    /** 本人以外が支払う */
    static readonly AGENT = new PAYMENT_EXISTENCE("1", "本人以外が支払う", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PAYMENT_EXISTENCE._values.push(this);
    }
}


// 送付先の有無
export class DESTINATION_EXISTENCE extends CodeMasterInterface {
    protected static  _values: DESTINATION_EXISTENCE[] = [];

    /** 管理費等の支払者に送付する */
    static readonly PRINCIPAL = new DESTINATION_EXISTENCE("0", "管理費等の支払者に送付する", 1);

    /** 上記以外に送付する */
    static readonly AGENT = new DESTINATION_EXISTENCE("1", "上記以外に送付する", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DESTINATION_EXISTENCE._values.push(this);
    }
}


// 組変用遷移元画面ID
export class OWNERSHIP_TRANSFER_REFERRER_ID extends CodeMasterInterface {
    protected static  _values: OWNERSHIP_TRANSFER_REFERRER_ID[] = [];

    /** トップ画面 */
    static readonly TOP = new OWNERSHIP_TRANSFER_REFERRER_ID("1", "トップ画面", 1);

    /** 入力画面 */
    static readonly INPUT = new OWNERSHIP_TRANSFER_REFERRER_ID("2", "入力画面", 2);

    /** 確認画面 */
    static readonly CONFIRM = new OWNERSHIP_TRANSFER_REFERRER_ID("3", "確認画面", 3);

    /** 提出完了画面 */
    static readonly COMPLETE = new OWNERSHIP_TRANSFER_REFERRER_ID("4", "提出完了画面", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        OWNERSHIP_TRANSFER_REFERRER_ID._values.push(this);
    }
}


// 賃貸の有無
export class RENT_EXISTENCE extends CodeMasterInterface {
    protected static  _values: RENT_EXISTENCE[] = [];

    /** 賃貸する */
    static readonly RENT = new RENT_EXISTENCE("1", "賃貸する", 1);

    /** 賃貸しない */
    static readonly NOT_RENT = new RENT_EXISTENCE("0", "賃貸しない", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RENT_EXISTENCE._values.push(this);
    }
}


// 組変状態
export class OWNERSHIP_TRANSFER_CONDITION extends CodeMasterInterface {
    protected static  _values: OWNERSHIP_TRANSFER_CONDITION[] = [];

    /** 閲覧・提出が可能 */
    static readonly POSSIBLE = new OWNERSHIP_TRANSFER_CONDITION("1", "閲覧・提出が可能", 1);

    /** 他社による提出済 */
    static readonly SUBMITTED_BY_OTHER = new OWNERSHIP_TRANSFER_CONDITION("2", "他社による提出済", 2);

    /** 仲介業者による提出待ち */
    static readonly WAITING_FOR_INTERMEDIARY = new OWNERSHIP_TRANSFER_CONDITION("3", "仲介業者による提出待ち", 3);

    /** 提出期限切れ */
    static readonly SUBMISSION_EXPIRED = new OWNERSHIP_TRANSFER_CONDITION("4", "提出期限切れ", 4);

    /** 閲覧期限切れ */
    static readonly VIEW_EXPIRED = new OWNERSHIP_TRANSFER_CONDITION("5", "閲覧期限切れ", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        OWNERSHIP_TRANSFER_CONDITION._values.push(this);
    }
}


// 入退室管理
export class ACCESS_CONTROL_MANAGER extends CodeMasterInterface {
    protected static  _values: ACCESS_CONTROL_MANAGER[] = [];

    /** オーデック・テクノ */
    static readonly ODEC_TECHNO = new ACCESS_CONTROL_MANAGER("1", "オーデック・テクノ", 1);

    /** LIM Cloud */
    static readonly LIM_CLOUD = new ACCESS_CONTROL_MANAGER("2", "LIM Cloud", 2);

    /** テブラパス（シブタニ） */
    static readonly TEBRA_PASS = new ACCESS_CONTROL_MANAGER("3", "テブラパス（シブタニ）", 3);

    /** RIKB（DBMS） */
    static readonly RIKB = new ACCESS_CONTROL_MANAGER("4", "RIKB（DBMS）", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ACCESS_CONTROL_MANAGER._values.push(this);
    }
}


// 管理組合の理事長登録状況
export class ASSOC_CHAIRMAN_REGISTRATION_STATUS extends CodeMasterInterface {
    protected static  _values: ASSOC_CHAIRMAN_REGISTRATION_STATUS[] = [];

    /** 要対応 */
    static readonly ACTION_REQUIRED = new ASSOC_CHAIRMAN_REGISTRATION_STATUS("1", "要対応", 1);

    /** 確認 */
    static readonly NOTICE = new ASSOC_CHAIRMAN_REGISTRATION_STATUS("2", "確認", 2);

    /** 済 */
    static readonly DONE = new ASSOC_CHAIRMAN_REGISTRATION_STATUS("3", "済", 3);

    /** 対象外 */
    static readonly NOT_SUBJECT = new ASSOC_CHAIRMAN_REGISTRATION_STATUS("4", "対象外", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        ASSOC_CHAIRMAN_REGISTRATION_STATUS._values.push(this);
    }
}


// 認証コードの送信先種別
export class AUTHENTICATION_CODE_TYPE extends CodeMasterInterface {
    protected static  _values: AUTHENTICATION_CODE_TYPE[] = [];

    /** SMS */
    static readonly SMS = new AUTHENTICATION_CODE_TYPE("1", "SMS", 1);

    /** 自動音声通話 */
    static readonly VOICE = new AUTHENTICATION_CODE_TYPE("2", "自動音声通話", 2);

    /** メール */
    static readonly EMAIL = new AUTHENTICATION_CODE_TYPE("3", "メール", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        AUTHENTICATION_CODE_TYPE._values.push(this);
    }
}


// 二段階認証利用区分
export class TWO_FACTOR_AUTH_CATEGORY extends CodeMasterInterface {
    protected static  _values: TWO_FACTOR_AUTH_CATEGORY[] = [];

    /** 組合員資格変更届 */
    static readonly OWNERSHIP_TRANSFER = new TWO_FACTOR_AUTH_CATEGORY("1", "組合員資格変更届", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        TWO_FACTOR_AUTH_CATEGORY._values.push(this);
    }
}


// 通知の種類
export class NOTIFICATION_CATEGORY extends CodeMasterInterface {
    protected static  _values: NOTIFICATION_CATEGORY[] = [];

    /** メッセージ公開 */
    static readonly PUBLISH_MESSAGE = new NOTIFICATION_CATEGORY("1", "メッセージ公開", 1);

    /** 請求額確定 */
    static readonly BILLING_AMOUNT = new NOTIFICATION_CATEGORY("2", "請求額確定", 2);

    /** 災害時モード設定 */
    static readonly DISASTER_MODE = new NOTIFICATION_CATEGORY("3", "災害時モード設定", 3);

    /** 総会 */
    static readonly GENERAL_MEETING = new NOTIFICATION_CATEGORY("4", "総会", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        NOTIFICATION_CATEGORY._values.push(this);
    }
}


// 設定有無
export class SET_EXISTENCE extends CodeMasterInterface {
    protected static  _values: SET_EXISTENCE[] = [];

    /** 設定なし */
    static readonly NOT = new SET_EXISTENCE("0", "設定なし", 2);

    /** 設定あり */
    static readonly SET = new SET_EXISTENCE("1", "設定あり", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SET_EXISTENCE._values.push(this);
    }
}


// 請求額・領収書権限設定（サブユーザ）
export class SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT extends CodeMasterInterface {
    protected static  _values: SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT[] = [];

    /** 閲覧できない */
    static readonly BROWSE_IMPOSSIBLE = new SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT("0", "閲覧できない", 3);

    /** 閲覧できる（領収書発行できない） */
    static readonly BROWSE_POSSIBLE_ISSUE_IMPOSSIBLE = new SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT("1", "閲覧できる（領収書発行できない）", 2);

    /** 閲覧できる（領収書発行できる） */
    static readonly BROWSE_POSSIBLE_ISSUE_POSSIBLE = new SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT("2", "閲覧できる（領収書発行できる）", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SUB_USER_AUTHORITY_SETTING_BILLING_RECEIPT._values.push(this);
    }
}


// 振替口座権限設定（サブユーザ）
export class SUB_USER_AUTHORITY_SETTING_ACCOUNT extends CodeMasterInterface {
    protected static  _values: SUB_USER_AUTHORITY_SETTING_ACCOUNT[] = [];

    /** 閲覧できない  */
    static readonly BROWSE_IMPOSSIBLE = new SUB_USER_AUTHORITY_SETTING_ACCOUNT("0", "閲覧できない ", 2);

    /** 閲覧できる */
    static readonly BROWSE_POSSIBLE = new SUB_USER_AUTHORITY_SETTING_ACCOUNT("1", "閲覧できる", 1);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        SUB_USER_AUTHORITY_SETTING_ACCOUNT._values.push(this);
    }
}


// 敬称
export class HONORIFICS extends CodeMasterInterface {
    protected static  _values: HONORIFICS[] = [];

    /** 御中（法人） */
    static readonly CORPORATION = new HONORIFICS("0", "御中（法人）", 1);

    /** 様（個人） */
    static readonly INDIVIDUAL = new HONORIFICS("1", "様（個人）", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        HONORIFICS._values.push(this);
    }
}


// お支払い状況
export class PAYMENT_STATUES extends CodeMasterInterface {
    protected static  _values: PAYMENT_STATUES[] = [];

    /** 請求中 */
    static readonly IN_REQUEST = new PAYMENT_STATUES("0", "請求中", 1);

    /** 支払い完了 */
    static readonly PAY_COMPLETE = new PAYMENT_STATUES("1", "支払い完了", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PAYMENT_STATUES._values.push(this);
    }
}


// 領収書発行ステータス
export class RECEIPT_ISSUE_STATUS extends CodeMasterInterface {
    protected static  _values: RECEIPT_ISSUE_STATUS[] = [];

    /** 新規発行 */
    static readonly NEW_ISSUE = new RECEIPT_ISSUE_STATUS("0", "新規発行", 1);

    /** 再発行 */
    static readonly RE_ISSUE = new RECEIPT_ISSUE_STATUS("1", "再発行", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RECEIPT_ISSUE_STATUS._values.push(this);
    }
}


// 災害時登録者種別
export class DISASTER_REGISTRANT_TYPE extends CodeMasterInterface {
    protected static  _values: DISASTER_REGISTRANT_TYPE[] = [];

    /** 管理組合 */
    static readonly ASSOC = new DISASTER_REGISTRANT_TYPE("1", "管理組合", 1);

    /** 管理会社 */
    static readonly MANAGEMENT_COMPANY = new DISASTER_REGISTRANT_TYPE("2", "管理会社", 2);

    /** システム */
    static readonly SYSTEM = new DISASTER_REGISTRANT_TYPE("3", "システム", 3);

    /** 居住者 */
    static readonly RESIDENT = new DISASTER_REGISTRANT_TYPE("4", "居住者", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISASTER_REGISTRANT_TYPE._values.push(this);
    }
}


// 災害時トピックカテゴリ
export class DISASTER_TOPIC_CATEGORY extends CodeMasterInterface {
    protected static  _values: DISASTER_TOPIC_CATEGORY[] = [];

    /** 依頼事項 */
    static readonly REQUEST_ITEMS = new DISASTER_TOPIC_CATEGORY("1", "依頼事項", 1);

    /** 情報共有 */
    static readonly INFORMATION_SHARING = new DISASTER_TOPIC_CATEGORY("2", "情報共有", 2);

    /** お知らせ */
    static readonly NOTICE = new DISASTER_TOPIC_CATEGORY("3", "お知らせ", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISASTER_TOPIC_CATEGORY._values.push(this);
    }
}


// 災害時公開区分
export class DISASTER_RELEASE_SETTING extends CodeMasterInterface {
    protected static  _values: DISASTER_RELEASE_SETTING[] = [];

    /** 常に公開 */
    static readonly PUBLIC = new DISASTER_RELEASE_SETTING("1", "常に公開", 1);

    /** 災害時モードのみ公開 */
    static readonly DISASTER = new DISASTER_RELEASE_SETTING("2", "災害時モードのみ公開", 2);

    /** 非公開 */
    static readonly PRIVATE = new DISASTER_RELEASE_SETTING("3", "非公開", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISASTER_RELEASE_SETTING._values.push(this);
    }
}


// 災害時モード解除・延長区分
export class DISASTER_MODE_RELEASE_EXTENSION extends CodeMasterInterface {
    protected static  _values: DISASTER_MODE_RELEASE_EXTENSION[] = [];

    /** 今すぐ解除する */
    static readonly RELEASE = new DISASTER_MODE_RELEASE_EXTENSION("1", "今すぐ解除する", 1);

    /** 延長する */
    static readonly EXTENSION = new DISASTER_MODE_RELEASE_EXTENSION("2", "延長する", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISASTER_MODE_RELEASE_EXTENSION._values.push(this);
    }
}


// 災害時コメントタイプ
export class DISASTER_COMMENT_TYPE extends CodeMasterInterface {
    protected static  _values: DISASTER_COMMENT_TYPE[] = [];

    /** 主コメント */
    static readonly MAIN_COMMENT = new DISASTER_COMMENT_TYPE("1", "主コメント", 1);

    /** 返信コメント */
    static readonly REPLY_COMMENT = new DISASTER_COMMENT_TYPE("2", "返信コメント", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISASTER_COMMENT_TYPE._values.push(this);
    }
}


// 災害時モード
export class DISASTER_MODE extends CodeMasterInterface {
    protected static  _values: DISASTER_MODE[] = [];

    /** ON */
    static readonly ON = new DISASTER_MODE("1", "ON", 1);

    /** OFF */
    static readonly OFF = new DISASTER_MODE("0", "OFF", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        DISASTER_MODE._values.push(this);
    }
}


// 登録区分
export class REGISTER_TYPE extends CodeMasterInterface {
    protected static  _values: REGISTER_TYPE[] = [];

    /** 登録済 */
    static readonly REGISTED = new REGISTER_TYPE("1", "登録済", 1);

    /** 未登録 */
    static readonly UNREGISTERD = new REGISTER_TYPE("0", "未登録", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        REGISTER_TYPE._values.push(this);
    }
}


// データ登録削除
export class REGISTER_OR_DELETE extends CodeMasterInterface {
    protected static  _values: REGISTER_OR_DELETE[] = [];

    /** 登録 */
    static readonly REGISTER = new REGISTER_OR_DELETE("0", "登録", 1);

    /** 削除 */
    static readonly DELETE = new REGISTER_OR_DELETE("1", "削除", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        REGISTER_OR_DELETE._values.push(this);
    }
}


// ユーザ登録申請拒否理由
export class USER_REGISTRATION_APPLY_REJECT_REASON extends CodeMasterInterface {
    protected static  _values: USER_REGISTRATION_APPLY_REJECT_REASON[] = [];

    /** 本人確認不一致 */
    static readonly MISMATCH = new USER_REGISTRATION_APPLY_REJECT_REASON("0", "本人確認不一致", 1);

    /** 新規登録 */
    static readonly NEW_REGISTER = new USER_REGISTRATION_APPLY_REJECT_REASON("1", "新規登録", 2);

    /** サブユーザ */
    static readonly SUB_USER = new USER_REGISTRATION_APPLY_REJECT_REASON("2", "サブユーザ", 3);

    /** 利用開始前 */
    static readonly BEFORE_PERIOD = new USER_REGISTRATION_APPLY_REJECT_REASON("3", "利用開始前", 4);

    /** smooth-e */
    static readonly SMOOTH_E = new USER_REGISTRATION_APPLY_REJECT_REASON("4", "smooth-e", 5);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        USER_REGISTRATION_APPLY_REJECT_REASON._values.push(this);
    }
}


// 災害時訓練モード
export class TRAINING_MODE_VALID_OR_NOT extends CodeMasterInterface {
    protected static  _values: TRAINING_MODE_VALID_OR_NOT[] = [];

    /** 実際の災害 */
    static readonly NOT = new TRAINING_MODE_VALID_OR_NOT("0", "実際の災害", 1);

    /** 訓練 */
    static readonly VALID = new TRAINING_MODE_VALID_OR_NOT("1", "訓練", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        TRAINING_MODE_VALID_OR_NOT._values.push(this);
    }
}


// 総会ステータス
export class GENERAL_MEETING_STATUS extends CodeMasterInterface {
    protected static  _values: GENERAL_MEETING_STATUS[] = [];

    /** 下書き */
    static readonly DRAFT = new GENERAL_MEETING_STATUS("1", "下書き", 1);

    /** 公開予約 */
    static readonly BEFORE_RELEASE = new GENERAL_MEETING_STATUS("2", "公開予約", 2);

    /** 公開中 */
    static readonly AFTER_RELEASE = new GENERAL_MEETING_STATUS("3", "公開中", 3);

    /** 公開中止 */
    static readonly CANCEL = new GENERAL_MEETING_STATUS("4", "公開中止", 4);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        GENERAL_MEETING_STATUS._values.push(this);
    }
}


// 決議の種類
export class RESOLUTION_TYPE extends CodeMasterInterface {
    protected static  _values: RESOLUTION_TYPE[] = [];

    /** 普通決議 */
    static readonly ORDINARY = new RESOLUTION_TYPE("1", "普通決議", 1);

    /** 特別決議 */
    static readonly SPECIAL = new RESOLUTION_TYPE("2", "特別決議", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        RESOLUTION_TYPE._values.push(this);
    }
}


// 意思表明の回答状況(総会単位)
export class VOTING_PREFERENCE_STATUS_SUMMARY extends CodeMasterInterface {
    protected static  _values: VOTING_PREFERENCE_STATUS_SUMMARY[] = [];

    /** ネット回答前 */
    static readonly BEFORE_NET_RESPONDED = new VOTING_PREFERENCE_STATUS_SUMMARY("1", "ネット回答前", 1);

    /** 回答済 */
    static readonly RESPONDED = new VOTING_PREFERENCE_STATUS_SUMMARY("2", "回答済", 2);

    /** 受付終了 */
    static readonly CLOSED = new VOTING_PREFERENCE_STATUS_SUMMARY("3", "受付終了", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VOTING_PREFERENCE_STATUS_SUMMARY._values.push(this);
    }
}


// 意思表明の回答状況(管理組合単位)
export class VOTING_PREFERENCE_STATUS extends CodeMasterInterface {
    protected static  _values: VOTING_PREFERENCE_STATUS[] = [];

    /** ネット回答前 */
    static readonly BEFORE_NET_RESPONDED = new VOTING_PREFERENCE_STATUS("1", "ネット回答前", 1);

    /** 回答済 */
    static readonly RESPONDED = new VOTING_PREFERENCE_STATUS("2", "回答済", 2);

    /** 受付終了 */
    static readonly CLOSED = new VOTING_PREFERENCE_STATUS("3", "受付終了", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VOTING_PREFERENCE_STATUS._values.push(this);
    }
}


// 意思表明の回答内容
export class VOTING_PREFERENCE_RESPONSE extends CodeMasterInterface {
    protected static  _values: VOTING_PREFERENCE_RESPONSE[] = [];

    /** 出席 */
    static readonly ATTENDANCE = new VOTING_PREFERENCE_RESPONSE("1", "出席", 1);

    /** 委任 */
    static readonly PROXY = new VOTING_PREFERENCE_RESPONSE("2", "委任", 2);

    /** 議決権行使 */
    static readonly VOTING = new VOTING_PREFERENCE_RESPONSE("3", "議決権行使", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VOTING_PREFERENCE_RESPONSE._values.push(this);
    }
}


// 委任タイプ
export class PROXY_TYPE extends CodeMasterInterface {
    protected static  _values: PROXY_TYPE[] = [];

    /** 議長 */
    static readonly CHAIRMAN = new PROXY_TYPE("1", "議長", 1);

    /** 代理人 */
    static readonly PROXY_VOTER = new PROXY_TYPE("2", "代理人", 2);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        PROXY_TYPE._values.push(this);
    }
}


// 投票ステータス
export class VOTE_STATUS extends CodeMasterInterface {
    protected static  _values: VOTE_STATUS[] = [];

    /** 賛成 */
    static readonly FOR = new VOTE_STATUS("1", "賛成", 1);

    /** 反対 */
    static readonly AGAINST = new VOTE_STATUS("2", "反対", 2);

    /** 棄権 */
    static readonly ABSTAIN = new VOTE_STATUS("3", "棄権", 3);

    /** コンストラクタ */
    private constructor(readonly value: string, readonly label: string, readonly displayOrder: number) {
        super(value, label, displayOrder);
        VOTE_STATUS._values.push(this);
    }
}
